// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T20:11:36.824Z
// Property: Highlands at Red Hawk (ID: 6767906449166794)
// Collections: 28 amenities, 12 floorplans (live), 49 photos, 34 POIs, 9 reviews, 3 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166794",
  "property_external_id": "jdd5lq6",
  "property_zillow_url": "https://www.zillow.com/apartments/castle-rock-co/highlands-at-red-hawk/CkBYDP/",
  "property_apartments_url": "https://www.apartments.com/highlands-at-red-hawk-castle-rock-co/jdd5lq6/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Highlands+at+Red+Hawk/data=!4m2!3m1!1s0x0:0x5ad9e1d4be59992a?sa=X&ved=2ahUKEwi6uP6f5qeSAxVPrlYBHSyXPfIQ_BJ6BAgKEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "41621673074",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "140HRH",
  "property_status": null,
  "property_slug": "highlands-at-red-hawk",
  "property_name": "Highlands at Red Hawk",
  "property_website_url": "https://www.highlandsatredhawkapts.com/",
  "property_domain": "https://www.highlandsatredhawkapts.com/",
  "property_address": "1465 Red Hawk Drive",
  "property_full_address": "1465 Red Hawk Dr, Castle Rock, CO 80109",
  "property_address_1": "1465 Red Hawk Dr",
  "property_address_2": null,
  "property_address_city": "Castle Rock",
  "property_address_state": "CO",
  "property_address_zip_full": null,
  "property_address_zip": "80109",
  "property_address_country": "US",
  "property_address_county": "Douglas County",
  "property_neighborhood_address": "South Douglas County",
  "property_address_latitude": "39.3806485",
  "property_address_longitude": "-104.8751353",
  "property_email": null,
  "property_phone": "(720) 573-6908",
  "property_call_tracking_phone": "855-387-6302",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Step into Highlands at Red Hawk, your serene sanctuary in Castle Rock, CO. Choose from spacious one, two, or three-bedroom floor plans featuring elegant design, stainless steel appliances, and breathtaking views. Enjoy premium amenities like a shimmering swimming pool, state-of-the-art fitness center, and beautiful parks nearby.  Find your new home today!",
  "property_long_description": "<p>Discover Highlands at Red Hawk: Your Ideal Castle Rock Retreat Welcome to Highlands at Red Hawk, where comfort meets convenience in beautiful Castle Rock, CO. Our thoughtfully designed apartment community offers a variety of spacious floor plans, including one, two, and three-bedroom options to perfectly suit your lifestyle. Each home features high-end finishes such as granite countertops, stainless steel appliances, and designer backsplashes, all complemented by stunning views and elegant touches like electric fireplaces and walk-in showers with custom tile. Our pet-friendly community is designed for both leisure and active living. Take advantage of our state-of-the-art fitness center, shimmering swimming pool, and beautifully landscaped grounds. Enjoy easy access to nearby shopping, dining, and public parks, making every day a new adventure. At Highlands at Red Hawk, we prioritize your comfort with on-site management and maintenance—offering 24-hour emergency services and courtesy patrol to ensure peace of mind. Additional amenities like a spacious clubhouse, guest parking, garages, and extra storage options cater to your every need. Whether you’re seeking a serene escape or a vibrant lifestyle, Highlands at Red Hawk is the perfect place to call home. With easy access to freeways, your next adventure is never far away. Find your new home today—browse our availability or schedule a tour to explore our community and see all that Highlands at Red Hawk has to offer! Your dream apartment awaits in Castle Rock!</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-b2e0-75e8-98c4-e9b2b849e952.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings at dusk with dramatic sunset sky.",
    "public_id": "019f805e-b2e0-75e8-98c4-e9b2b849e952",
    "storage_key": "property/6767906449166794/019f805e-b2e0-75e8-98c4-e9b2b849e952.webp",
    "width": 3072,
    "height": 2049
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166794/019ffc73-a2ba-733c-bc10-bde428bb5828.mp4",
  "property_featured_video_media": {
    "public_id": "019ffc73-a2ba-733c-bc10-bde428bb5828",
    "storage_key": "property/6767906449166794/019ffc73-a2ba-733c-bc10-bde428bb5828.mp4",
    "thumbnail_key": "property/6767906449166794/019ffc73-a2ba-733c-bc10-bde428bb5828_thumb.webp",
    "size_bytes": 27303510,
    "classification": "Community",
    "title": "Discover Our Apartment Community's Amenities",
    "description": "Explore the resort-style pool, state-of-the-art fitness center, and resident lounge. Enjoy the best apartment living with our top-notch amenities."
  },
  "property_total_units": "56",
  "property_year_built": "2017",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.64285714285714",
  "property_admin_fee": "200",
  "property_application_fee": "68.67",
  "property_fees_deposit_info": "$750-$1250 Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "1",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "1 pet max per household. Breed restrictions apply.",
  "property_pet_policy_description": "The Highlands at Red Hawk Apartments is a pet friendly community. We allow 1 pet max per household. $300 pet fee is required. Monthly pet rent: $35 per pet. Breed restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://www.myrentalapplication.com/index/amchighlandsatredhawk",
  "property_resident_portal_url": "https://highlandsatredhawk.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amchighlandsatredhawk",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-5449-701e-99c9-93002aed2036.webp",
  "property_primary_logo_media": {
    "alt_text": "Highlands at Red Hawk logo with trees and a hawk.",
    "public_id": "019d02cf-5449-701e-99c9-93002aed2036",
    "storage_key": "property/6767906449166794/019d02cf-5449-701e-99c9-93002aed2036.webp",
    "width": 286,
    "height": 95
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-5449-701e-99c9-93002aed2036.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Highlands at Red Hawk logo with trees and a hawk.",
    "public_id": "019d02cf-5449-701e-99c9-93002aed2036",
    "storage_key": "property/6767906449166794/019d02cf-5449-701e-99c9-93002aed2036.webp",
    "width": 286,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-5449-701e-99c9-93002aed2036.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Highlands at Red Hawk logo with trees and a hawk.",
    "public_id": "019d02cf-5449-701e-99c9-93002aed2036",
    "storage_key": "property/6767906449166794/019d02cf-5449-701e-99c9-93002aed2036.webp",
    "width": 286,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#273239",
  "property_secondary_color": "#AA4A44",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "751 - 1295",
  "property_sqft_min": "751",
  "property_sqft_max": "1295",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/highlandsatredhawkapartments/",
  "property_instagram_url": "https://www.instagram.com/highlandsatredhawkco/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJBb9fy0iYbIcRKplZvtTh2Vo",
  "property_youtube_url": "https://www.youtube.com/watch?t=77&v=nE8L3mK9rWQ",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Property+Management&find_loc=Castle+Rock%2C+CO",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Highlands at Red Hawk",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Highlands at Red Hawk, where your new home awaits in picturesque Castle Rock, CO. Enjoy easy access to freeways, shopping, and public parks. Unwind in our shimmering pool, state-of-the-art fitness center, and beautifully landscaped grounds—crafted for comfort and style. Life here is a blend of convenience and luxury. ",
  "property_home_floorplans_blurb": "Nestled in the heart of Castle Rock, Highlands at Red Hawk offers an array of thoughtfully designed apartment floor plans, each tailored to elevate your living experience. Dive into a community that blends comfort, style, and a vibrant lifestyle—browse our available homes to find your perfect fit today!",
  "property_home_gallery_blurb": "Welcome to Highlands at Red Hawk in scenic Castle Rock, CO, where luxury meets comfort. With stunning views, beautifully landscaped grounds, and modern amenities like a shimmering pool and state-of-the-art fitness center, your new home promises an unparalleled lifestyle. Picture yourself living here and embracing a vibrant community.",
  "property_home_neighborhood_blurb": "At Highlands at Red Hawk, vibrant living meets the charm of Castle Rock, CO. Enjoy nearby attractions like the serenity of Philip S. Miller Park, the history at the Castle Rock Historical Society, and the excitement of Ninja Intensity. Embrace a lifestyle rich in both adventure and community!",
  "property_home_reviews_blurb": "At Highlands at Red Hawk, nestled in scenic Castle Rock, CO, residents praise the \"friendly atmosphere and beautiful surroundings.\" Join a thriving community where comfort meets convenience. Curious about life here? Check out what our residents have to say about their experiences in this stunning apartment haven!",
  "property_neighborhood_blurb": "<p>Life at Highlands at Red Hawk puts everyday Castle Rock within easy reach. Stock up at Whole Foods Market, browse the Outlets at Castle Rock, or tee off at Red Hawk Ridge Golf Course—all minutes from home. When you want a quieter afternoon, Douglas County Libraries and nearby favorites like Great Divide Brewery &amp; Roadhouse keep the day close by.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Highlands at Red Hawk, where luxury meets comfort in Castle Rock, CO. Our stunning floor plans—ranging from one to three bedrooms—feature designer finishes, stainless steel appliances, and spacious walk-in closets. Unwind by the shimmering pool, enjoy the state-of-the-art fitness center, or explore nearby parks. Experience exceptional living today!",
  "property_applynow_blurb": "Welcome to Highlands at Red Hawk in beautiful Castle Rock, CO—where modern living meets natural beauty. Choose from spacious one, two, or three-bedroom floor plans loaded with designer finishes. Embrace the lifestyle with a shimmering pool, state-of-the-art fitness center, and easy access to shopping. Your perfect home awaits! ",
  "property_contactus_blurb": "At Highlands at Red Hawk in Castle Rock, CO, we offer thoughtfully designed floor plans tailored to your lifestyle, whether you're seeking a cozy one-bedroom or a spacious three-bedroom apartment. Our leasing team is here to assist you. Have questions? Contact us today to learn more about your future home!",
  "property_faqs_blurb": "At Highlands at Red Hawk in Castle Rock, CO, we offer thoughtfully designed one, two, and three-bedroom floor plans, perfectly tailored for your lifestyle. Have questions? Our FAQs page is your go-to resource for all things related to our vibrant community. Find the answers you need today!",
  "property_floorplans_blurb": "At Highlands at Red Hawk in Castle Rock, CO, your ideal space awaits! Choose from our thoughtfully designed one, two, and three-bedroom floor plans that blend comfort and style. Each layout is crafted to elevate your living experience. Browse our available apartment homes and find the perfect fit for your lifestyle!",
  "property_gallery_blurb": "At Highlands at Red Hawk in Castle Rock, CO, our stunning photo gallery invites you to envision life in spacious one to three-bedroom homes, complete with designer finishes and breathtaking views. Imagine relaxing by the shimmering pool or enjoying our state-of-the-art fitness center—all just moments away from shopping and dining. Picture yourself living here!",
  "property_interactivemap_blurb": "At Highlands at Red Hawk in Castle Rock, CO, each apartment features exquisite amenities like granite countertops, stainless steel appliances, and breathtaking views. Enjoy easy access to shopping, dining, and public parks, all while indulging in our shimmering swimming pool and state-of-the-art fitness center. Your new home awaits!",
  "property_pets_blurb": "At Highlands at Red Hawk in Castle Rock, CO, your furry friend is part of the family! Our pet-friendly apartments invite you to share a home with your beloved companion. Enjoy scenic views and nature trails, ensuring both you and your pet feel right at home in this vibrant community.",
  "property_referafriend_blurb": "At Highlands at Red Hawk in Castle Rock, CO, our inviting one, two, and three-bedroom apartments are perfect for your next chapter. Share the warm community vibe with friends—great friends make great neighbors! Refer a friend today and let them experience the lifestyle you love.",
  "property_residentaccess_blurb": "Welcome to the Highlands at Red Hawk, where spacious one, two, and three-bedroom floor plans meet the vibrant lifestyle of Castle Rock, CO. From seamless rent payments to effortless maintenance requests, access your resident portal to unlock a community designed for your comfort and convenience—your new home awaits!",
  "property_reviews_blurb": "At Highlands at Red Hawk in Castle Rock, CO, our residents rave about their living experience: “The community has a welcoming atmosphere, and the staff goes above and beyond!” Dive into our reviews to see why our apartment community is the perfect place to call home. Your future awaits!",
  "property_created_at": "1762201005702",
  "property_scheduletour_blurb": "Experience life at Highlands at Red Hawk in Castle Rock, CO, where our diverse floor plans—from cozy one-bedrooms to spacious three-bedrooms—meet your unique lifestyle. Schedule a tour today and see why our residents love calling this community home! Your ideal apartment awaits among stunning views and vibrant surroundings.",
  "property_thankyou_blurb": "Thank you for reaching out to Highlands at Red Hawk in beautiful Castle Rock, CO! Our diverse floor plans—ranging from cozy one-bedroom retreats to spacious three-bedroom havens—offer the perfect space for every lifestyle. Expect a prompt response from our team as we help you find your ideal home!",
  "property_virtualtours_blurb": "Step into your dream living space at Highlands at Red Hawk, where beautiful one, two, and three-bedroom apartments await in scenic Castle Rock, CO. Embrace spacious floor plans and modern amenities. Take a virtual tour today and envision your future in this vibrant community!",
  "property_copyright": "2025 All Rights Reserved. Highlands at Red Hawk",
  "property_seo_title_home": "Highlands at Red Hawk |  Apartments in Castle Rock, CO",
  "property_seo_description_home": "Elevate your lifestyle at Highlands at Red Hawk in Castle Rock, CO. Enjoy spacious floor plans, top-tier amenities, and stunning views. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Castle Rock, CO Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Highlands at Red Hawk in Castle Rock, CO! From cozy one-bedrooms to spacious three-bedrooms, we have the perfect floor plan for you.",
  "property_seo_title_amenities": "Amenities | Castle Rock, CO Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury living at Highlands at Red Hawk, Castle Rock! Enjoy breathtaking views, a top-notch fitness center, and pet-friendly spaces.",
  "property_seo_title_gallery": "Gallery | Apartments in Castle Rock, CO",
  "property_seo_description_gallery": "Escape to Highlands at Red Hawk, Castle Rock, CO! Enjoy stunning views, stylish apartments, and great amenities like a pool and fitness center.",
  "property_seo_title_virtualtours": "Virtual Tours | Highlands at Red Hawk Apartments",
  "property_seo_description_virtualtours": "Step inside Highlands at Red Hawk in Castle Rock, CO! Take a virtual tour to see our one, two, and three-bedroom apartments—your perfect home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Highlands at Red Hawk Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Highlands at Red Hawk, Castle Rock, CO: stunning views, luxurious amenities, and pet-friendly living await!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Castle Rock, CO",
  "property_seo_description_neighborhood": "Uncover the charm of Castle Rock at Highlands at Red Hawk. Dive into local favorites and hotspots that make our vibrant neighborhood truly special!",
  "property_seo_title_contact": "Contact Us | Highlands at Red Hawk",
  "property_seo_description_contact": "Connect with the Highlands at Red Hawk in Castle Rock, CO. Whether it's one, two, or three bedrooms, we're here to help. Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Castle Rock, CO",
  "property_seo_description_faqs": "Uncover the answers you need about Highlands at Red Hawk in Castle Rock, CO. From pet policies to amenities, find your perfect home and community vibe!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Castle Rock, CO",
  "property_seo_description_reviews": "Experience life at Highlands at Red Hawk in Castle Rock, CO. Read resident reviews and see why our community is the perfect place to call home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Castle Rock, CO",
  "property_seo_description_applynow": "Discover luxury living at Highlands at Red Hawk, Castle Rock, CO. Enjoy 1-3 bedroom homes with a pool, gym, and breathtaking views!",
  "property_seo_title_residentaccess": "Resident Access | Highlands at Red Hawk",
  "property_seo_description_residentaccess": "Streamline your living at Highlands at Red Hawk! Access your resident portal here to pay rent, request maintenance, and manage your Castle Rock home easily.",
  "property_seo_title_referafriend": "Refer A Friend | Highlands at Red Hawk",
  "property_seo_description_referafriend": "Refer a friend to Highlands at Red Hawk in Castle Rock, CO! Great friends make great neighbors—invite them to experience our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Highlands at Red Hawk",
  "property_seo_description_scheduletour": "Experience elevated living at Highlands at Red Hawk in Castle Rock, CO. Schedule your tour today and step into your future home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Highlands at Red Hawk",
  "property_seo_description_privacy": "At Highlands at Red Hawk, your privacy matters. Uncover how we safeguard your data and ensure a secure living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Highlands at Red Hawk",
  "property_seo_description_accessibility": "Experience accessibility at Highlands at Red Hawk in Castle Rock, CO. We prioritize inclusion and invite you to join our welcoming community!",
  "property_seo_title_sitemap": "Sitemap | Highlands at Red Hawk",
  "property_seo_description_sitemap": "Navigate the charm of Highlands at Red Hawk in Castle Rock, CO! Check our sitemap for a comprehensive guide to your future home and community amenities.",
  "property_seo_title_thankyou": "Thank You | Highlands at Red Hawk",
  "property_seo_description_thankyou": "Thank you for reaching out to Highlands at Red Hawk in Castle Rock! A team member will be in touch soon to guide you to your new home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Castle Rock, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293651155",
  "amenities": [
    {
      "id": "ec_702542b9b8332a51ded12040",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Freeways",
      "amount": "false",
      "description": "Matches exactly as listed under “Community Amenities and Features” on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f5538ad31b4b23276ee8474",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Shopping and Dining",
      "amount": "false",
      "description": "Matches exactly as listed under “Community Amenities and Features” on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8868a3fb0f7ee8c8f0792312",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Public Parks Nearby",
      "amount": "false",
      "description": "Matches exactly as listed under “Community Amenities and Features” on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b2c51ff5efae9a1a7884d27",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "Listed exactly as “Pet Friendly” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6e9eb7a5f1b459165dde35f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "Listed exactly as “Clubhouse” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb0cb3aa7b638941e08f5cb6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Garage",
      "amount": "false",
      "description": "Listed exactly as “Garage” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62fbcae82bc6d79f14284bda",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "State‑of‑the‑Art Fitness Center",
      "amount": "false",
      "description": "Listed exactly as “State‑of‑the‑Art Fitness Center” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f7423dc3b29bcbc35bbd3f6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "Listed exactly as “Shimmering Swimming Pool” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78384150e5287f854f5cda4e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "Listed exactly as “Guest Parking” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8384301868cf4b41561de6ca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "On‑Site Maintenance",
      "amount": "false",
      "description": "Listed exactly as “On‑Site Maintenance” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f0bd1ab25cdfc307d3d276c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "On‑Site Management",
      "amount": "false",
      "description": "Listed exactly as “On‑Site Management” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de5e567739e7e7161b695157",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "Listed exactly as “24‑Hour Emergency Maintenance” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a82b3a5bbcce2a39f86e6f0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Courtesy Patrol",
      "amount": "false",
      "description": "Listed exactly as “24‑Hour Courtesy Patrol” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbd3e989d2476fca8a695e71",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "Listed exactly as “Beautiful Landscaping” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_faf1c9b7d625cb931cf5aa8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Breathtaking Views",
      "amount": "false",
      "description": "Listed exactly as “Breathtaking Views” under Community Features on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8170a2524b3609e6bc829ef7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "Listed exactly as “Granite Countertops” under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7927ff5c8534df564473e20",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "Listed exactly as “Stainless Steel Appliances” under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b31bf145f800181664855d17",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Designer Backsplash",
      "amount": "false",
      "description": "Listed exactly as “Designer Backsplash” under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eaec4c5b4a6765d3cab4f920",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Breakfast Bars",
      "amount": "false",
      "description": "Listed exactly as “Breakfast Bars” under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f4bb3ea41606c0e0679e098",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Pantry*",
      "amount": "false",
      "description": "Listed as “Pantry*” (with asterisk) under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c566f3d0bea0257f6b1a27d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets*",
      "amount": "false",
      "description": "Listed as “Walk‑in Closets*” (with asterisk) under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_123f6e7672a807c1b23e7120",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Electric Fireplace*",
      "amount": "false",
      "description": "Listed as “Electric Fireplace*” (with asterisk) under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71858ea98a855f06643694e0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Designer Fixtures and Finishes",
      "amount": "false",
      "description": "Listed exactly as “Designer Fixtures and Finishes” under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43c4fd50ac61031e91376c77",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Shower with Custom Tile",
      "amount": "false",
      "description": "Listed exactly as “Walk‑in Shower with Custom Tile” under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8daa7b001ffd28ce44e46fab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Washer & Dryer in each Home",
      "amount": "false",
      "description": "Listed exactly as “Washer & Dryer in each Home” under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_451f35b7d06547a6a6764421",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Central Air & Heating",
      "amount": "false",
      "description": "Listed exactly as “Central Air & Heating” under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcb5b30de95e6afbea497cbc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Extra Storage Available",
      "amount": "false",
      "description": "Listed exactly as “Extra Storage Available” under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d5770b9ea5a9e07094b3ea9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "external_id": "false",
      "title": "Views Available",
      "amount": "false",
      "description": "Listed exactly as “Views Available” under Apartments Amenities and Features on the official amenities page.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_72acd6df-49c0-4f1b-8273-2c6ffe316896",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-aec6-7661-9fa1-0fcc4e9e9953.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with garages and balconies under a clear blue sky.",
        "public_id": "019f805f-aec6-7661-9fa1-0fcc4e9e9953",
        "storage_key": "property/6767906449166794/019f805f-aec6-7661-9fa1-0fcc4e9e9953.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "View of the apartment complex exterior, showcasing the architecture with garages and balconies. Enjoy comfortable living in this vibrant community.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with garages and balconies under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3364b999-7a94-4351-b7ab-cca4fd0b8fb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-9804-75fb-a674-ad42f7bad1b3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019f805f-9804-75fb-a674-ad42f7bad1b3",
        "storage_key": "property/6767906449166794/019f805f-9804-75fb-a674-ad42f7bad1b3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and beautiful landscaping. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5cd68923-239b-4c4d-b226-1c14d567d50c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-995b-723d-9c24-3ff1b17d3c9f.webp",
      "image_media": {
        "alt_text": "Outdoor built-in grill with stone surround and metal fence.",
        "public_id": "019f805f-995b-723d-9c24-3ff1b17d3c9f",
        "storage_key": "property/6767906449166794/019f805f-995b-723d-9c24-3ff1b17d3c9f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy cooking outdoors with our high-quality built-in grill, perfect for community gatherings and resident events.",
      "link": "",
      "alt_text": "Outdoor built-in grill with stone surround and metal fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a5968b40-0c5b-4663-9f1e-e761131eb0c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-4b41-773d-b2b9-878a04c8eee4.webp",
      "image_media": {
        "alt_text": "The Highlands at Red Hawk apartment building exterior with a brightly colored locker system.",
        "public_id": "019f805f-4b41-773d-b2b9-878a04c8eee4",
        "storage_key": "property/6767906449166794/019f805f-4b41-773d-b2b9-878a04c8eee4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Discover the vibrant exteriors of The Highlands at Red Hawk, featuring unique artistic touches like this distinctive locker system.",
      "link": "",
      "alt_text": "The Highlands at Red Hawk apartment building exterior with a brightly colored locker system.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0c7b2fa6-107e-4630-a90d-4efaf361a8d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-4482-72a0-b64e-4b045d674f5a.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with balconies and stone accents.",
        "public_id": "019f805f-4482-72a0-b64e-4b045d674f5a",
        "storage_key": "property/6767906449166794/019f805f-4482-72a0-b64e-4b045d674f5a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings, showcasing their balconies and stone detailing, set against a clear blue sky.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with balconies and stone accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_402f0f55-db9e-441e-b247-a154cfc5a29a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-3024-77ad-a268-5260c549dd9f.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with attached garages and stone accents.",
        "public_id": "019f805f-3024-77ad-a268-5260c549dd9f",
        "storage_key": "property/6767906449166794/019f805f-3024-77ad-a268-5260c549dd9f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "View of apartment buildings showcasing their exterior design with attached garages and architectural stone details, set against a clear blue sky.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with attached garages and stone accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e6da7c2-dc66-44fb-ae41-60f8ad69fdc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-a813-756f-ba0f-feb754ab04f4.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and surrounding landscape.",
        "public_id": "019f805e-a813-756f-ba0f-feb754ab04f4",
        "storage_key": "property/6767906449166794/019f805e-a813-756f-ba0f-feb754ab04f4.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living in this apartment community, featuring a refreshing pool and scenic views.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a pool and surrounding landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_61c3ee9e-d8de-4fc1-a023-c19e9ff874d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-44fa-703e-ab18-0c25cee416c8.webp",
      "image_media": {
        "alt_text": "Leasing office entrance with mailboxes and reserved parking signs.",
        "public_id": "019f805f-44fa-703e-ab18-0c25cee416c8",
        "storage_key": "property/6767906449166794/019f805f-44fa-703e-ab18-0c25cee416c8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Visit our leasing office to learn more about our community and available apartments. Mailboxes and reserved parking are conveniently located nearby.",
      "link": "",
      "alt_text": "Leasing office entrance with mailboxes and reserved parking signs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f321fef-320f-48b8-b4f8-5ecb91e6bcab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-c21a-750c-88d1-14a4fc06b8fa.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and lush green landscaping.",
        "public_id": "019f805e-c21a-750c-88d1-14a4fc06b8fa",
        "storage_key": "property/6767906449166794/019f805e-c21a-750c-88d1-14a4fc06b8fa.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring private balconies and beautifully maintained grounds, offering a serene living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and lush green landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b9970d2b-f46a-4f96-b031-a64c79ba3096",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-c1c9-7218-bcda-f562dc4798cb.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with stone accents and balconies.",
        "public_id": "019f805e-c1c9-7218-bcda-f562dc4798cb",
        "storage_key": "property/6767906449166794/019f805e-c1c9-7218-bcda-f562dc4798cb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of a multifamily apartment building with stone and siding, featuring balconies and surrounding greenery.",
      "link": "",
      "alt_text": "Apartment building exterior with stone accents and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fc9c4ebe-007c-4646-bcf5-03ef16816ded",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-b2e0-75e8-98c4-e9b2b849e952.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings at dusk with dramatic sunset sky.",
        "public_id": "019f805e-b2e0-75e8-98c4-e9b2b849e952",
        "storage_key": "property/6767906449166794/019f805e-b2e0-75e8-98c4-e9b2b849e952.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Beautiful apartment exteriors at dusk, showcasing the property's architecture and landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings at dusk with dramatic sunset sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_afaa7935-9144-424d-b673-d5e6abec2ceb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-c0d1-7323-b0c2-4ff17ba20681.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019f805e-c0d1-7323-b0c2-4ff17ba20681",
        "storage_key": "property/6767906449166794/019f805e-c0d1-7323-b0c2-4ff17ba20681.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and scenic apartment buildings. Perfect for relaxing on a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f74d464f-ced2-41cb-abc1-1f25b58b3372",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-a7d6-7408-a339-0334239c9b12.webp",
      "image_media": {
        "alt_text": "Apartment complex with garages and a mountain in the background.",
        "public_id": "019f805e-a7d6-7408-a339-0334239c9b12",
        "storage_key": "property/6767906449166794/019f805e-a7d6-7408-a339-0334239c9b12.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings with garages and a scenic mountain landscape.",
      "link": "",
      "alt_text": "Apartment complex with garages and a mountain in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_313f8015-6e33-4957-a6ef-004721f9b77e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-8a9d-71ff-ad8c-a48015aaa8c4.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with surrounding homes and a hilly landscape.",
        "public_id": "019f805e-8a9d-71ff-ad8c-a48015aaa8c4",
        "storage_key": "property/6767906449166794/019f805e-8a9d-71ff-ad8c-a48015aaa8c4.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "An aerial view showcases a modern multifamily property nestled within a suburban landscape, featuring well-maintained buildings, a swimming pool, and a backdrop of rolling hills and residential homes.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with surrounding homes and a hilly landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_76fab914-44f8-4297-812b-4a9d28c07abb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-b4a7-71e4-9444-ddb6fb178c2f.webp",
      "image_media": {
        "alt_text": "The Highlands at Redhawk monument sign, a luxury apartment community.",
        "public_id": "019f805e-b4a7-71e4-9444-ddb6fb178c2f",
        "storage_key": "property/6767906449166794/019f805e-b4a7-71e4-9444-ddb6fb178c2f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to The Highlands at Redhawk, a luxury apartment community offering an exceptional living experience.",
      "link": "",
      "alt_text": "The Highlands at Redhawk monument sign, a luxury apartment community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1d6cd469-fe76-4858-9df1-3db574dddf7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-7521-77c7-9c18-e408bbfe377a.webp",
      "image_media": {
        "alt_text": "Empty living room with kitchen counter and sliding glass doors leading to an outdoor patio.",
        "public_id": "019f805f-7521-77c7-9c18-e408bbfe377a",
        "storage_key": "property/6767906449166794/019f805f-7521-77c7-9c18-e408bbfe377a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area with modern finishes, including a granite countertop and beautiful wood-look flooring. Enjoy natural light and access to your patio through large sliding doors.",
      "link": "",
      "alt_text": "Empty living room with kitchen counter and sliding glass doors leading to an outdoor patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a164c343-f010-413e-9297-5c80ab6fac4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-8aee-7517-b95d-f06eb7fdf9c8.webp",
      "image_media": {
        "alt_text": "Kitchen island with sink and dishwasher, granite countertops.",
        "public_id": "019f805f-8aee-7517-b95d-f06eb7fdf9c8",
        "storage_key": "property/6767906449166794/019f805f-8aee-7517-b95d-f06eb7fdf9c8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a large island with a double sink, granite countertops, and a stainless steel dishwasher. Pendant lighting above the island.",
      "link": "",
      "alt_text": "Kitchen island with sink and dishwasher, granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0bae58fa-3a95-4182-8694-81ee357dba09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-8a3e-706c-aec9-5d1153729cb1.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019f805f-8a3e-706c-aec9-5d1153729cb1",
        "storage_key": "property/6767906449166794/019f805f-8a3e-706c-aec9-5d1153729cb1.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully designed kitchen featuring granite countertops, modern stainless steel appliances, and plenty of storage.",
      "link": "",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9e8cc2c9-2de1-4e70-b6b1-1d3bb0b7354f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-89d8-7389-a4a1-f65c7703c1ad.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen counter in apartment",
        "public_id": "019f805f-89d8-7389-a4a1-f65c7703c1ad",
        "storage_key": "property/6767906449166794/019f805f-89d8-7389-a4a1-f65c7703c1ad.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious dining area with wood-look flooring and a view of the outdoors, adjacent to a modern kitchen with granite countertops and subway tile backsplash.",
      "link": "",
      "alt_text": "Dining area and kitchen counter in apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5ad4b2e8-236c-4768-be2d-eb603ea523f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-76a1-7025-9eb4-05ee370012d1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019f805f-76a1-7025-9eb4-05ee370012d1",
        "storage_key": "property/6767906449166794/019f805f-76a1-7025-9eb4-05ee370012d1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed kitchen featuring granite countertops, a breakfast bar, and modern stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_143947b9-d892-4049-8b74-3ab9282a1ee2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-7580-760e-9307-0ecd9c3d2a2f.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet and two windows.",
        "public_id": "019f805f-7580-760e-9307-0ecd9c3d2a2f",
        "storage_key": "property/6767906449166794/019f805f-7580-760e-9307-0ecd9c3d2a2f.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom with plush carpeting, large windows, and ample space for furniture.",
      "link": "",
      "alt_text": "Empty bedroom with carpet and two windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13a412ea-3835-4770-9e89-e75d79f3e4bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-9489-7144-a1c5-c28c6385c78d.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and pendant lighting.",
        "public_id": "019f805f-9489-7144-a1c5-c28c6385c78d",
        "storage_key": "property/6767906449166794/019f805f-9489-7144-a1c5-c28c6385c78d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring granite countertops, a double sink, dishwasher, and stainless steel refrigerator, complemented by elegant pendant lighting.",
      "link": "",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and pendant lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9fc4d69c-3808-4a29-9125-1d316196d5ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-6349-73cc-852e-351e20b5686f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops",
        "public_id": "019f805f-6349-73cc-852e-351e20b5686f",
        "storage_key": "property/6767906449166794/019f805f-6349-73cc-852e-351e20b5686f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space, seamlessly opening to the living area.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_93cfcdeb-4aab-4eee-8f99-0519593734ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-9028-76d8-b9e8-45e9286b316d.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and bathtub/shower combo.",
        "public_id": "019f805f-9028-76d8-b9e8-45e9286b316d",
        "storage_key": "property/6767906449166794/019f805f-9028-76d8-b9e8-45e9286b316d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A well-lit bathroom featuring a double vanity with granite countertops, a toilet, and a bathtub with a tiled shower surround.",
      "link": "",
      "alt_text": "Bathroom with a vanity, toilet, and bathtub/shower combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_32b17d9b-feb6-406a-a4bd-8685338c2342",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-71d4-721d-a393-942f8ec0d5b4.webp",
      "image_media": {
        "alt_text": "Empty living room with wood floors and a sliding glass door leading outside.",
        "public_id": "019f805f-71d4-721d-a393-942f8ec0d5b4",
        "storage_key": "property/6767906449166794/019f805f-71d4-721d-a393-942f8ec0d5b4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and bright living area with wood plank flooring, large windows, and a neutral color palette, perfect for any decor.",
      "link": "",
      "alt_text": "Empty living room with wood floors and a sliding glass door leading outside.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e7c72ec5-1a3e-4fde-853a-e97aadd131f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-7041-71fc-9cbf-9cf7cfc5599c.webp",
      "image_media": {
        "alt_text": "Gourmet kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019f805f-7041-71fc-9cbf-9cf7cfc5599c",
        "storage_key": "property/6767906449166794/019f805f-7041-71fc-9cbf-9cf7cfc5599c.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Prepare meals in style in this modern kitchen featuring granite countertops, a double-basin sink, stainless steel dishwasher, and rich wood cabinetry.",
      "link": "",
      "alt_text": "Gourmet kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d6b1561-b4d0-46f9-928d-7a34674ba4c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-7495-74f3-9e96-4a3d89cfc880.webp",
      "image_media": {
        "alt_text": "Kitchen and entryway with white door and granite countertops",
        "public_id": "019f805f-7495-74f3-9e96-4a3d89cfc880",
        "storage_key": "property/6767906449166794/019f805f-7495-74f3-9e96-4a3d89cfc880.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen with stainless steel appliances and granite countertops, leading into the entryway of an apartment home.",
      "link": "",
      "alt_text": "Kitchen and entryway with white door and granite countertops",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31802c92-a430-432f-9c64-b4ef74c35227",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-6e85-745f-9d56-60c048878435.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops",
        "public_id": "019f805f-6e85-745f-9d56-60c048878435",
        "storage_key": "property/6767906449166794/019f805f-6e85-745f-9d56-60c048878435.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek kitchen, complete with stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ee76161c-0be0-4581-86e4-c927da86f89b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-7c1c-761b-89cc-01ab46abee4a.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub.",
        "public_id": "019f805f-7c1c-761b-89cc-01ab46abee4a",
        "storage_key": "property/6767906449166794/019f805f-7c1c-761b-89cc-01ab46abee4a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a granite-top vanity, toilet, and bathtub with tiled walls. Includes ample storage with built-in shelving.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b026f11b-c920-4979-b461-f418c997694c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-4281-73aa-878d-ca13ccfd1b0c.webp",
      "image_media": {
        "alt_text": "Game room with foosball and arcade games, opening to a fitness center.",
        "public_id": "019f805f-4281-73aa-878d-ca13ccfd1b0c",
        "storage_key": "property/6767906449166794/019f805f-4281-73aa-878d-ca13ccfd1b0c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy fun and games in our resident game room, complete with foosball, arcade games, and a TV area. Adjacent fitness center included.",
      "link": "",
      "alt_text": "Game room with foosball and arcade games, opening to a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e453de83-9c32-45d3-83f4-9b51a9b0d3ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-3fde-734a-9d6d-be3a5a6a343a.webp",
      "image_media": {
        "alt_text": "Foosball table with Colorado Avalanche branding, featuring miniature hockey players on an ice rink.",
        "public_id": "019f805f-3fde-734a-9d6d-be3a5a6a343a",
        "storage_key": "property/6767906449166794/019f805f-3fde-734a-9d6d-be3a5a6a343a.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a game of foosball on the Colorado Avalanche-themed table, perfect for recreation and fun in the community.",
      "link": "",
      "alt_text": "Foosball table with Colorado Avalanche branding, featuring miniature hockey players on an ice rink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60cb638c-dd81-4ef5-9109-fd25a5e82c69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-3141-7305-a69e-a3fd7bc85fa3.webp",
      "image_media": {
        "alt_text": "Foosball table and arcade games in a community game room.",
        "public_id": "019f805f-3141-7305-a69e-a3fd7bc85fa3",
        "storage_key": "property/6767906449166794/019f805f-3141-7305-a69e-a3fd7bc85fa3.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy hours of fun in our community game room, featuring a foosball table and exciting arcade games.",
      "link": "",
      "alt_text": "Foosball table and arcade games in a community game room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5d87e27a-50ba-49d0-a56f-211450a99d17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-4399-7598-92ee-9a6a9db82f98.webp",
      "image_media": {
        "alt_text": "Community game room with foosball table, arcade games, and a table with chairs.",
        "public_id": "019f805f-4399-7598-92ee-9a6a9db82f98",
        "storage_key": "property/6767906449166794/019f805f-4399-7598-92ee-9a6a9db82f98.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy fun and games in our community's well-equipped game room, featuring a foosball table and classic arcade machines. Perfect for friendly competition!",
      "link": "",
      "alt_text": "Community game room with foosball table, arcade games, and a table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_108d75cf-bfcc-4d5e-aba3-3ca76311bfd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-2ac6-7345-b5d0-ddc2a5b01f2a.webp",
      "image_media": {
        "alt_text": "Arcade games including Big Buck HD and Pac-Man Pixel Bash.",
        "public_id": "019f805f-2ac6-7345-b5d0-ddc2a5b01f2a",
        "storage_key": "property/6767906449166794/019f805f-2ac6-7345-b5d0-ddc2a5b01f2a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy classic arcade games like Big Buck HD and Pac-Man Pixel Bash in the community game room.",
      "link": "",
      "alt_text": "Arcade games including Big Buck HD and Pac-Man Pixel Bash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_090eaf92-c3fa-47ee-a53a-0b5f71df018a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-bef5-7409-a384-2270abd11e29.webp",
      "image_media": {
        "alt_text": "Multifamily property fitness center with treadmills, elliptical, weight rack, and bench.",
        "public_id": "019f805e-bef5-7409-a384-2270abd11e29",
        "storage_key": "property/6767906449166794/019f805e-bef5-7409-a384-2270abd11e29.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, an elliptical machine, and a full weight rack with bench.",
      "link": "",
      "alt_text": "Multifamily property fitness center with treadmills, elliptical, weight rack, and bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0bdaff4-a67e-48fa-810f-1771e1298a86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-2e1a-75eb-8b60-7bd0ae2fca96.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, dumbbells, and a weight bench.",
        "public_id": "019f805f-2e1a-75eb-8b60-7bd0ae2fca96",
        "storage_key": "property/6767906449166794/019f805f-2e1a-75eb-8b60-7bd0ae2fca96.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, weight machines, and free weights for residents to enjoy.",
      "link": "",
      "alt_text": "Gym with treadmills, weight machines, dumbbells, and a weight bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aed97638-4ebb-4052-9ab5-8c3da677fe68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-c119-715c-94b7-549031060bd7.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, and exercise balls.",
        "public_id": "019f805e-c119-715c-94b7-549031060bd7",
        "storage_key": "property/6767906449166794/019f805e-c119-715c-94b7-549031060bd7.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and free weights.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df9bba86-6c26-4a09-b8e7-a19b190042a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-c00b-715c-a821-7737a8c84ef5.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, and free weights.",
        "public_id": "019f805e-c00b-715c-a821-7737a8c84ef5",
        "storage_key": "property/6767906449166794/019f805e-c00b-715c-a821-7737a8c84ef5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with treadmills, weight machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Gym with treadmills, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d089556e-15b5-40aa-924e-4c466f564198",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-2e1a-75eb-8b60-7ed77b21297a.webp",
      "image_media": {
        "alt_text": "Coffee station with Keurig, K-cup holder, microwave, air fryer, and mini-fridge.",
        "public_id": "019f805f-2e1a-75eb-8b60-7ed77b21297a",
        "storage_key": "property/6767906449166794/019f805f-2e1a-75eb-8b60-7ed77b21297a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks at our convenient coffee station, complete with a Keurig, microwave, air fryer, and mini-fridge.",
      "link": "",
      "alt_text": "Coffee station with Keurig, K-cup holder, microwave, air fryer, and mini-fridge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f16d050f-8ac0-4426-b0a8-39992b478135",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-c250-7208-91cb-f471cd8efb07.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops, open to living area with sliding glass door.",
        "public_id": "019f805e-c250-7208-91cb-f471cd8efb07",
        "storage_key": "property/6767906449166794/019f805e-c250-7208-91cb-f471cd8efb07.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space, opening to a bright living area with outdoor views.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops, open to living area with sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_828d748a-e40e-49c1-ac9b-34d24989e92d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-1b00-7521-aaea-3f710ab0b14b.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, shower, and granite vanity.",
        "public_id": "019f805f-1b00-7521-aaea-3f710ab0b14b",
        "storage_key": "property/6767906449166794/019f805f-1b00-7521-aaea-3f710ab0b14b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a bathtub with tiled shower surround and a granite-topped vanity with a sink.",
      "link": "",
      "alt_text": "Bathroom with bathtub, shower, and granite vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bfc8072e-471b-4418-9980-b00e66fb0c9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-057d-704d-9544-f0a8ff1ae379.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, tub, and closet shelves",
        "public_id": "019f805f-057d-704d-9544-f0a8ff1ae379",
        "storage_key": "property/6767906449166794/019f805f-057d-704d-9544-f0a8ff1ae379.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A spacious bathroom featuring a granite-top vanity, a bathtub, and ample shelving for storage.",
      "link": "",
      "alt_text": "Bathroom with vanity, tub, and closet shelves",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45c306f2-4c11-4729-8979-f3bffcb0a72f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-c29f-747d-8acd-af61afbcf03a.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral carpet and three large windows.",
        "public_id": "019f805e-c29f-747d-8acd-af61afbcf03a",
        "storage_key": "property/6767906449166794/019f805e-c29f-747d-8acd-af61afbcf03a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush neutral carpeting and abundant natural light from three large windows. Perfect for creating your personal sanctuary.",
      "link": "",
      "alt_text": "Empty bedroom with neutral carpet and three large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b83482d7-be16-4deb-904e-671316ff530d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-bf87-748e-bcfb-558e6e69658b.webp",
      "image_media": {
        "alt_text": "Bedroom with blinds on window and two doors, one opening to kitchen.",
        "public_id": "019f805e-bf87-748e-bcfb-558e6e69658b",
        "storage_key": "property/6767906449166794/019f805e-bf87-748e-bcfb-558e6e69658b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, a large window with blinds, and access to other areas of the apartment, including the kitchen.",
      "link": "",
      "alt_text": "Bedroom with blinds on window and two doors, one opening to kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3da40094-1722-41f6-bd16-2748d634b229",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-120a-767f-9a5d-5087424488b0.webp",
      "image_media": {
        "alt_text": "Single vanity with granite countertop and dark wood cabinets in a bathroom.",
        "public_id": "019f805f-120a-767f-9a5d-5087424488b0",
        "storage_key": "property/6767906449166794/019f805f-120a-767f-9a5d-5087424488b0.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a single vanity with a granite countertop and ample storage, complemented by a large mirror and modern light fixture.",
      "link": "",
      "alt_text": "Single vanity with granite countertop and dark wood cabinets in a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_54c3cc6b-0cfd-4f11-b96c-e30164bcccce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-d87a-7243-b26b-852c570a08e9.webp",
      "image_media": {
        "alt_text": "Interior view of a toilet and adjacent hallway.",
        "public_id": "019f805e-d87a-7243-b26b-852c570a08e9",
        "storage_key": "property/6767906449166794/019f805e-d87a-7243-b26b-852c570a08e9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A clean and modern apartment bathroom featuring a toilet and a hallway view.",
      "link": "",
      "alt_text": "Interior view of a toilet and adjacent hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d8a044b-9954-4053-a870-1d5cd139be43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805f-5778-729d-a356-9d6716f88c51.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet",
        "public_id": "019f805f-5778-729d-a356-9d6716f88c51",
        "storage_key": "property/6767906449166794/019f805f-5778-729d-a356-9d6716f88c51.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c7c3a49-99f6-4a75-b968-9208f3bf1acd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-c08a-71ea-b933-b72a8d8af274.webp",
      "image_media": {
        "alt_text": "Hallway with multiple doors and wood flooring",
        "public_id": "019f805e-c08a-71ea-b933-b72a8d8af274",
        "storage_key": "property/6767906449166794/019f805e-c08a-71ea-b933-b72a8d8af274.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious hallway featuring multiple doors, wood-look flooring, and modern lighting. Provides access to various areas within the apartment.",
      "link": "",
      "alt_text": "Hallway with multiple doors and wood flooring",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf38c2cb-49be-4d65-80e7-5fc97a23e8af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019f805e-b61b-729e-ba7d-66ae07ac75ce.webp",
      "image_media": {
        "alt_text": "Open white door revealing a closet with a shelf, and another doorway leading to a room with hardwood floors.",
        "public_id": "019f805e-b61b-729e-ba7d-66ae07ac75ce",
        "storage_key": "property/6767906449166794/019f805e-b61b-729e-ba7d-66ae07ac75ce.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into spacious living with ample storage. This apartment features a walk-in closet and elegant hardwood floors in adjoining rooms.",
      "link": "",
      "alt_text": "Open white door revealing a closet with a shelf, and another doorway leading to a room with hardwood floors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0fcd0891-cfeb-4da9-9b9d-ff7dbb18f16b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Savina's Mexican Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "6361 Promenade Pkwy, Castle Rock, CO 80108, USA",
      "poi_short_description": "Mexican kitchen turning out mesquite-grilled fajitas & burritos in a stylish, brick-lined space.",
      "poi_long_description": "People say this Mexican restaurant serves delicious chili rellenos, chimichangas, and margaritas. They highlight the beautiful mountain views, especially at sunset, and the fun, lively atmosphere with fire pits on the patio. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-65a6-74b4-80ab-7a45bed28328.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-65a6-74b4-80ab-7a45bed28328",
        "storage_key": "property/6767906449166794/019d02d0-65a6-74b4-80ab-7a45bed28328.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://savinasmexicankitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1462446235020483855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "savinas-mexican-kitchen",
      "poi_latitude": "39.4219916",
      "poi_longitude": "-104.8803479",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-632-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2791-749d-a0fa-f86fedd351aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2791-749d-a0fa-f86fedd351aa",
        "storage_key": "property/6767906449166794/019d02d0-2791-749d-a0fa-f86fedd351aa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxRnNXf6ZbIcRD92ANRqnSxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_a927fa99-067d-4f4a-a7fd-8339eae1252b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "5470 Factory Shops Blvd, Castle Rock, CO 80108, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious cheeseburgers, animal fries, and fresh-made pink lemonade iced tea. They also highlight the friendly and efficient staff, fast service, and great value for the price.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-6558-74dd-8451-022f79505917.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-6558-74dd-8451-022f79505917",
        "storage_key": "property/6767906449166794/019d02d0-6558-74dd-8451-022f79505917.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/378",
      "poi_directions_map_url": "https://maps.google.com/?cid=319633621312334884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "39.4158346",
      "poi_longitude": "-104.8764515",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2791-749d-a0fa-f86fedd351aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2791-749d-a0fa-f86fedd351aa",
        "storage_key": "property/6767906449166794/019d02d0-2791-749d-a0fa-f86fedd351aa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZMJE3aZbIcRJOyXyBWRbwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_91b9b85f-dc9b-460d-b8d9-9d5a8d5211b9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Los Dos Potrillos Castle Rock",
      "poi_type": "Restaurants",
      "poi_address": "6370 Promenade Pkwy, Castle Rock, CO 80108, USA",
      "poi_short_description": "Restaurant supplying Mexican favorites & margaritas in a colorful, lively atmosphere.",
      "poi_long_description": "People say this Mexican restaurant serves delicious fajitas, molcajete, and margaritas. They highlight the generous portions, fresh ingredients, and authentic flavors. They also like the beautiful views and vibrant atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-ea68-75e9-89c9-7dd7c594cf52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-ea68-75e9-89c9-7dd7c594cf52",
        "storage_key": "property/6767906449166794/019d02cf-ea68-75e9-89c9-7dd7c594cf52.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.los2potrillos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8565173914739501720&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "los-dos-potrillos-castle-rock",
      "poi_latitude": "39.420188",
      "poi_longitude": "-104.877739",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 720-769-5474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2791-749d-a0fa-f86fedd351aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2791-749d-a0fa-f86fedd351aa",
        "storage_key": "property/6767906449166794/019d02d0-2791-749d-a0fa-f86fedd351aa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDwfzp1qZbIcRmGp9k0uc3XY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_a9a3007a-6869-4643-aa8b-bf6a0087c261",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Great Divide Brewery & Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "215 Wilcox St, Castle Rock, CO 80104, USA",
      "poi_short_description": "Bustling destination with an informal ambiance offering hearty comfort classics, plus craft beer.",
      "poi_long_description": "Diners say this American restaurant serves up delicious chicken pot pie, short rib enchiladas, and fried pickles, and they praise the extensive beer selection. They also highlight the friendly and attentive service, and the energetic and cozy atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-ea56-71ed-adbe-b3f408480e25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-ea56-71ed-adbe-b3f408480e25",
        "storage_key": "property/6767906449166794/019d02cf-ea56-71ed-adbe-b3f408480e25.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.greatdividebreweryandroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=346208412559952657&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-divide-brewery--roadhouse",
      "poi_latitude": "39.371592",
      "poi_longitude": "-104.8604871",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 303-955-5788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2791-749d-a0fa-f86fedd351aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2791-749d-a0fa-f86fedd351aa",
        "storage_key": "property/6767906449166794/019d02d0-2791-749d-a0fa-f86fedd351aa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6ramD2YbIcREUvjiLf6zQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a2937203-c1d7-4c09-aaf3-69df2f1ccbb3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "5012 Founders Pkwy, Castle Rock, CO 80108, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves yummy chicken fingers, Texas toast, and Cane's sauce. They also highlight the fresh, hot food, and the clean restaurant.\n\nSome reviews mention that orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-f0cf-73be-8255-d4d66225ac31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-f0cf-73be-8255-d4d66225ac31",
        "storage_key": "property/6767906449166794/019d02cf-f0cf-73be-8255-d4d66225ac31.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/co/castle-rock/5012-founders-parkway",
      "poi_directions_map_url": "https://maps.google.com/?cid=14592362633013341134&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "39.4078962",
      "poi_longitude": "-104.8580938",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-688-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2791-749d-a0fa-f86fedd351aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2791-749d-a0fa-f86fedd351aa",
        "storage_key": "property/6767906449166794/019d02d0-2791-749d-a0fa-f86fedd351aa.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3KpO8OZbIcRzqtxRoB8gso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b997cf9e-3628-4d44-b43b-5b29149affdb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Outlets at Castle Rock",
      "poi_type": "Shopping & Retail",
      "poi_address": "5050 Factory Shops Blvd #437, Castle Rock, CO 80108, USA",
      "poi_short_description": "Busy, modern outlet mall featuring a variety of popular stores, along with a food court.",
      "poi_long_description": "Shoppers say this shopping center offers a wide variety of stores with great deals on clothes and shoes, and many mention the friendly staff and clean facilities. They also highlight the beautiful mountain views and convenient parking.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.outletsatcastlerock.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16555845973818578810&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "outlets-at-castle-rock",
      "poi_latitude": "39.4139383",
      "poi_longitude": "-104.8727642",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-688-4495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-27bd-7059-9bb0-3bf78ba1e21b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-27bd-7059-9bb0-3bf78ba1e21b",
        "storage_key": "property/6767906449166794/019d02d0-27bd-7059-9bb0-3bf78ba1e21b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqybY65OZbIcRepeJUTIuwuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c34191f1-a9cd-4b5a-84ff-660e37b90240",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6384 Promenade Pkwy, Castle Rock, CO 80108, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of premium, high-quality food, including fresh produce, meats, and bakery items. They also highlight the clean and organized store, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-f1b6-75bd-b008-e44bd18b2ee6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-f1b6-75bd-b008-e44bd18b2ee6",
        "storage_key": "property/6767906449166794/019d02cf-f1b6-75bd-b008-e44bd18b2ee6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/castlerock?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=9237594806540630013&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "39.4231397",
      "poi_longitude": "-104.8773497",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 720-673-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2798-752a-96fe-38ec99cae4f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2798-752a-96fe-38ec99cae4f9",
        "storage_key": "property/6767906449166794/019d02d0-2798-752a-96fe-38ec99cae4f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOaMXDxqZbIcR_ffYnoiHMoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_31dd18ce-4244-48c6-8f4c-e71777faf90a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "King Soopers Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "5544 Promenade Pkwy, Castle Rock, CO 80108, USA",
      "poi_short_description": "Grocery chain selling produce, organic products, and prepared foods, plus a pharmacy.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, a deli, and a bakery. They also highlight the friendly staff and clean environment.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-f196-72dd-baf2-e6ea66a620bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-f196-72dd-baf2-e6ea66a620bb",
        "storage_key": "property/6767906449166794/019d02cf-f196-72dd-baf2-e6ea66a620bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kingsoopers.com/stores/grocery/co/castle-rock/promenade-parkway/620/00125?cid=loc_62000125_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=18426461387297248552&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "king-soopers-marketplace",
      "poi_latitude": "39.414899",
      "poi_longitude": "-104.8796862",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-562-9128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2798-752a-96fe-38ec99cae4f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2798-752a-96fe-38ec99cae4f9",
        "storage_key": "property/6767906449166794/019d02d0-2798-752a-96fe-38ec99cae4f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ00sGgZCZbIcRKNVNEQHxt_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_053bb109-3345-4dd6-bfae-c8bcf8f944f8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1360 New Beale St, Castle Rock, CO 80108, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are willing to assist customers in finding what they need. They also highlight the clean and well-stocked store, making it a convenient one-stop shop for various home improvement projects.\n\nSome reviews mention the customer service can be inconsistent, with some staff members being more responsive than others.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-f68f-7216-bd6f-67ca282cc6e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-f68f-7216-bd6f-67ca282cc6e8",
        "storage_key": "property/6767906449166794/019d02cf-f68f-7216-bd6f-67ca282cc6e8.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/CO-Castle-Rock/2274?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2274-_-na-_-0-_-0&y_source=1_MTE4MzkwNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12800035939879492328&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "39.4121304",
      "poi_longitude": "-104.8762515",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-239-0355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-27bd-7059-9bb0-3bf78ba1e21b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-27bd-7059-9bb0-3bf78ba1e21b",
        "storage_key": "property/6767906449166794/019d02d0-27bd-7059-9bb0-3bf78ba1e21b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyRgmuJWZbIcR6BrArN7corE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_913a320a-c615-47ce-bc5d-a1a230b51778",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Nike Factory Store - Castle Rock",
      "poi_type": "Shopping & Retail",
      "poi_address": "5050 Factory Shops Blvd #905, Castle Rock, CO 80108, USA",
      "poi_short_description": "Part of a chain selling sports clothing for men, women, and kids, plus shoes.",
      "poi_long_description": "Shoppers say this sportswear store offers a wide selection of shoes and clothing at great prices, with many mentioning the good deals and discounts available. They also highlight the friendly and helpful staff, who are knowledgeable about the different products.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-f814-773e-8492-05ca6d5348c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-f814-773e-8492-05ca6d5348c8",
        "storage_key": "property/6767906449166794/019d02cf-f814-773e-8492-05ca6d5348c8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nike.com/retail/s/nike-factory-store-castle-rock?cp=84620811901_seo_%3Fcp%3D84620811901_seo_&y_source=1_NTQzNzYzNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8969264247687074829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike-factory-store---castle-rock",
      "poi_latitude": "39.4166193",
      "poi_longitude": "-104.8750057",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-688-3013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-27bd-7059-9bb0-3bf78ba1e21b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-27bd-7059-9bb0-3bf78ba1e21b",
        "storage_key": "property/6767906449166794/019d02d0-27bd-7059-9bb0-3bf78ba1e21b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjeFbb5SZbIcRDdT_4086eXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_dfe14ea0-35f2-4efb-99b6-ba40e3ec825a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Douglas County Libraries - Philip & Jerry Miller Library",
      "poi_type": "Education",
      "poi_address": "100 S Wilcox St, Castle Rock, CO 80104, USA",
      "poi_short_description": "Public library featuring a large number of study rooms, as well as meeting spaces, and a kids' story time.",
      "poi_long_description": "People say this public library is clean and has friendly and helpful staff. They also highlight the spacious and well-lit study areas, the abundance of new books, and the fun and interactive children's section with a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-f85f-728e-9a80-efb0c4711456.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-f85f-728e-9a80-efb0c4711456",
        "storage_key": "property/6767906449166794/019d02cf-f85f-728e-9a80-efb0c4711456.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.dcl.org/castle-rock/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6990471809308727003&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "douglas-county-libraries---philip--jerry-miller-library",
      "poi_latitude": "39.36820549999999",
      "poi_longitude": "-104.8598936",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-791-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-27be-76ff-8837-e09a15cd06f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-27be-76ff-8837-e09a15cd06f0",
        "storage_key": "property/6767906449166794/019d02d0-27be-76ff-8837-e09a15cd06f0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLxDPqReYbIcR25Y6zhIlA2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_75718837-492c-441e-8cda-63f6c5942d5b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Arapahoe Community College",
      "poi_type": "Education",
      "poi_address": "4500 Limelight Ave, Castle Rock, CO 80109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-f984-779b-adee-5a45127be94a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-f984-779b-adee-5a45127be94a",
        "storage_key": "property/6767906449166794/019d02cf-f984-779b-adee-5a45127be94a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.arapahoe.edu/about-acc/locations/castle-rock-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=2810585177308970932&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arapahoe-community-college",
      "poi_latitude": "39.4090093",
      "poi_longitude": "-104.8864209",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-660-3160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-27be-76ff-8837-e09a15cd06f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-27be-76ff-8837-e09a15cd06f0",
        "storage_key": "property/6767906449166794/019d02d0-27be-76ff-8837-e09a15cd06f0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJb00UsCZbIcRtL964FM0ASc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_59b118b2-7a54-4721-99e6-1ca200671a10",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Douglas County Libraries",
      "poi_type": "Education",
      "poi_address": "360 Village Square Ln, Castle Pines, CO 80108, USA",
      "poi_short_description": "Clean branch offering books for all ages plus DVD rentals, kids' areas and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-fc9c-7072-9f12-30bc07b198b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-fc9c-7072-9f12-30bc07b198b9",
        "storage_key": "property/6767906449166794/019d02cf-fc9c-7072-9f12-30bc07b198b9.webp",
        "width": 480,
        "height": 327
      },
      "poi_business_url": "https://www.dcl.org/castle-pines/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5540209922431133679&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "douglas-county-libraries",
      "poi_latitude": "39.4702258",
      "poi_longitude": "-104.8794762",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-791-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-27be-76ff-8837-e09a15cd06f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-27be-76ff-8837-e09a15cd06f0",
        "storage_key": "property/6767906449166794/019d02d0-27be-76ff-8837-e09a15cd06f0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT-vIzveabIcR7yeaN5LH4kw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_7edb5aac-d07e-45ab-a076-7954f58828b2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "The Castle Rock",
      "poi_type": "Entertainment",
      "poi_address": "Castle Rock, CO 80104, USA",
      "poi_short_description": "Free landmark destination offering several trails for short climbs to the top of the rock that surveys the town.",
      "poi_long_description": "People say this historical landmark offers a fun, quick hike with great views of the surrounding suburbs and distant mountains. They highlight the easy walk up and the beautiful, well-kept trails. They also like that it's a suitable hike for families with little kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-6db8-71de-b549-e50ff3929c4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-6db8-71de-b549-e50ff3929c4a",
        "storage_key": "property/6767906449166794/019d02d0-6db8-71de-b549-e50ff3929c4a.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12952919147956633924&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-castle-rock",
      "poi_latitude": "39.3788746",
      "poi_longitude": "-104.8556782",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQHWISWYbIcRRIFPalYDwrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_06db80a8-2cc6-48d8-8410-7e4b6ab9a5f8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Castle Rock Historical Society and Museum",
      "poi_type": "Entertainment",
      "poi_address": "420 Elbert St, Castle Rock, CO 80104, USA",
      "poi_short_description": "Displays on heritage, geology & military history in a relocated stone rail depot building.",
      "poi_long_description": "Displays on heritage, geology & military history in a relocated stone rail depot building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-6d42-729f-a3be-2156fed9874a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-6d42-729f-a3be-2156fed9874a",
        "storage_key": "property/6767906449166794/019d02d0-6d42-729f-a3be-2156fed9874a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.castlerockmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=885039818943744691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "castle-rock-historical-society-and-museum",
      "poi_latitude": "39.3740622",
      "poi_longitude": "-104.8624615",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-814-3164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2cc2-76f5-a86e-4dc1b5e8f811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2cc2-76f5-a86e-4dc1b5e8f811",
        "storage_key": "property/6767906449166794/019d02d0-2cc2-76f5-a86e-4dc1b5e8f811.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJEyUCGDyYbIcRs8o3tAZLSAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6830acaa-c91c-406f-94c8-ffdb877e1fc9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "McAwesome Ranch",
      "poi_type": "Entertainment",
      "poi_address": "3039 Haystack Rd, Castle Rock, CO 80104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02cf-ffd2-733c-b219-e2299dd46a5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-ffd2-733c-b219-e2299dd46a5c",
        "storage_key": "property/6767906449166794/019d02cf-ffd2-733c-b219-e2299dd46a5c.webp",
        "width": 1280,
        "height": 399
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13403684746448497955&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcawesome-ranch",
      "poi_latitude": "39.352947",
      "poi_longitude": "-104.843583",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 702-767-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ17kixf-XbIcRI21i2UJ0A7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_9f97aeb9-e8ea-4d9b-8f51-99d5f50b9425",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Sedalia Museum and Gardens",
      "poi_type": "Entertainment",
      "poi_address": "4037-A North, Platte Ave, Sedalia, CO 80135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-043f-76af-9584-a6f4df7ee5d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-043f-76af-9584-a6f4df7ee5d6",
        "storage_key": "property/6767906449166794/019d02d0-043f-76af-9584-a6f4df7ee5d6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7337143022578454143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedalia-museum-and-gardens",
      "poi_latitude": "39.4383608",
      "poi_longitude": "-104.9625726",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 720-823-2999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2cc2-76f5-a86e-4dc1b5e8f811.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2cc2-76f5-a86e-4dc1b5e8f811",
        "storage_key": "property/6767906449166794/019d02d0-2cc2-76f5-a86e-4dc1b5e8f811.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVgwB0CcbIcRf04Gh7TE0mU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_06a51525-fecc-4509-aef4-0e47477c9775",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5745 New Abbey Ln, Castle Rock, CO 80108, USA",
      "poi_short_description": "Chain fitness center offering cardio and strength-training machines, as well as classes and a pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-05d0-77e9-9e9e-d4bc5a096812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-05d0-77e9-9e9e-d4bc5a096812",
        "storage_key": "property/6767906449166794/019d02d0-05d0-77e9-9e9e-d4bc5a096812.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/castle-rock-co/castle-rock-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=2817389950247830146&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "39.4177942",
      "poi_longitude": "-104.8826614",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-209-8636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZtFqZqZbIcRggJHijthGSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_71d87baa-0800-4c43-bd0e-2727abb615bb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Founders Pkwy, Castle Rock, CO 80104, USA",
      "poi_short_description": "Chain gym offering a variety of equipment, as well as tanning and spa services, in a 24-hour facility.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, including free weights, cardio machines, and adjustable machines suitable for different body types. They also highlight the clean and functional environment, the friendly and helpful staff, and the positive and motivating atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-6f52-772a-9f8c-af2ae0d8e6e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-6f52-772a-9f8c-af2ae0d8e6e4",
        "storage_key": "property/6767906449166794/019d02d0-6f52-772a-9f8c-af2ae0d8e6e4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/castle-rock-co?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13116717619342663654&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.411541",
      "poi_longitude": "-104.8646165",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-952-4484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNSFr0f-ZbIcR5t8G8C3xB7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ecf394e1-c194-45e7-a097-cd143a938134",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Animal Care Center of Castle Pines",
      "poi_type": "Health and Wellness",
      "poi_address": "562 Castle Pines Pkwy C5, Castle Rock, CO 80108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-07dd-7207-86a5-65c87a44f5b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-07dd-7207-86a5-65c87a44f5b3",
        "storage_key": "property/6767906449166794/019d02d0-07dd-7207-86a5-65c87a44f5b3.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "https://animalcarectr.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=17782534378388551005&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-care-center-of-castle-pines",
      "poi_latitude": "39.4699987",
      "poi_longitude": "-104.8743212",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-688-3660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ehPGb6ZbIcRXXUFHs1AyPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_4a0d4010-24ca-47f4-9c4b-3319ad09c3ad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Origins Salon, Castle Rock CO.",
      "poi_type": "Health and Wellness",
      "poi_address": "402 Wilcox St, Castle Rock, CO 80104, USA",
      "poi_short_description": "Salon specializing in women's haircuts, plus coloring, extensions, and blow dry memberships.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-0cfc-75d9-914e-b5b0b56074a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-0cfc-75d9-914e-b5b0b56074a7",
        "storage_key": "property/6767906449166794/019d02d0-0cfc-75d9-914e-b5b0b56074a7.webp",
        "width": 705,
        "height": 396
      },
      "poi_business_url": "https://www.originssalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6533585701377490314&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "origins-salon-castle-rock-co",
      "poi_latitude": "39.3735314",
      "poi_longitude": "-104.8597364",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-688-7481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YSjnFmZbIcRij0tOJT1q1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9c39fc72-a235-4ee1-812e-a2aa1db7f9fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Veterinary Specialists of the Rockies",
      "poi_type": "Health and Wellness",
      "poi_address": "774 Maleta Ln, Castle Rock, CO 80108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-751e-7112-b9e3-c7c3d73b5b7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-751e-7112-b9e3-c7c3d73b5b7a",
        "storage_key": "property/6767906449166794/019d02d0-751e-7112-b9e3-c7c3d73b5b7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://vetsoftherockies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13209558738997243935&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterinary-specialists-of-the-rockies",
      "poi_latitude": "39.407101",
      "poi_longitude": "-104.854346",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-660-1027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvYX6E3SZbIcRH3CWla_HUbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_6ecafb3b-a370-44f3-b8ff-7faa22fea753",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Castle Rock Chameleon Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "4807 Industrial Way # 101, Castle Rock, CO 80109, USA",
      "poi_short_description": "Kids'-oriented gymnastics center featuring classes, private lessons and team programs.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://portal.iclasspro.com/chameleongym/dashboard",
      "poi_directions_map_url": "https://maps.google.com/?cid=1954799111807812668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "castle-rock-chameleon-gymnastics",
      "poi_latitude": "39.4088581",
      "poi_longitude": "-104.8737206",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-733-3687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-27be-76ff-8837-e09a15cd06f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-27be-76ff-8837-e09a15cd06f0",
        "storage_key": "property/6767906449166794/019d02d0-27be-76ff-8837-e09a15cd06f0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2ehPGb6ZbIcRPMSNam_XIBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3bfca510-de35-42f4-a80e-cf8ba7f82c0a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Ninja Intensity",
      "poi_type": "Health and Wellness",
      "poi_address": "2275 Manatt Ct, Castle Rock, CO 80104, USA",
      "poi_short_description": "Ninja gym for classes and open gym, plus birthday parties and school events.",
      "poi_long_description": "People say this gym offers challenging and engaging ninja courses, with options for all skill levels, including advanced and competitive. They highlight the supportive, positive, and low-pressure environment, and the clean, safe facilities. They also like the attentive, helpful, and enthusiastic staff, and the fun tournaments that attract American Ninja Warrior stars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-0f14-7173-9f83-522e8818815a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-0f14-7173-9f83-522e8818815a",
        "storage_key": "property/6767906449166794/019d02d0-0f14-7173-9f83-522e8818815a.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.ninjaintensity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=201766416115931717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ninja-intensity",
      "poi_latitude": "39.3503728",
      "poi_longitude": "-104.870868",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-515-4395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY6n2IDGYbIcRRZoxiHzRzAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_493ad647-3de6-44b4-80ba-a9a1b4143b78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Floyd's 99 Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "5642 Allen Way Ste 102, Castle Rock, CO 80108, USA",
      "poi_short_description": "Family-friendly hair-styling and beard salon featuring kids' cuts and professional products, along with friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-134a-710e-be9e-b1260669f8d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-134a-710e-be9e-b1260669f8d3",
        "storage_key": "property/6767906449166794/019d02d0-134a-710e-be9e-b1260669f8d3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.floydsbarbershop.com/castle-rock/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2160429414890990333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "floyds-99-barbershop",
      "poi_latitude": "39.41441890000001",
      "poi_longitude": "-104.8639427",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-814-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIc4useuZbIcR_erhPBtj-x0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_cf3e1646-e2e7-4c51-8a9a-4b23ac89e288",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "M. Vince' Nail Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "6376 Promenade Pkwy unit 400, Castle Rock, CO 80108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-1502-7167-ab50-7eeacce8ae7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-1502-7167-ab50-7eeacce8ae7b",
        "storage_key": "property/6767906449166794/019d02d0-1502-7167-ab50-7eeacce8ae7b.webp",
        "width": 1280,
        "height": 1094
      },
      "poi_business_url": "http://www.mvincenailspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10691668641957449555&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "m-vince-nail-spa",
      "poi_latitude": "39.421938",
      "poi_longitude": "-104.8758367",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-284-7169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJndmyy8WZbIcRU48OpPtvYJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_0a124708-1029-4eb0-aa02-f40d890876d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Scissors & Scotch",
      "poi_type": "Health and Wellness",
      "poi_address": "20 Wilcox St Suite C-104, Castle Rock, CO 80104, USA",
      "poi_short_description": "Upscale men's parlor featuring haircuts, beard trims and straight-razor shaves, plus cocktails and beers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-76b6-77ad-a554-4f8b75bc62f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-76b6-77ad-a554-4f8b75bc62f2",
        "storage_key": "property/6767906449166794/019d02d0-76b6-77ad-a554-4f8b75bc62f2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://scissorsscotch.com/locations/co/casle-rock/encore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2476429195952771462&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scissors--scotch",
      "poi_latitude": "39.3692964",
      "poi_longitude": "-104.8595893",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 303-953-2579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2c50-74d8-af8b-1c6dba554f6a",
        "storage_key": "property/6767906449166794/019d02d0-2c50-74d8-af8b-1c6dba554f6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC8Z4gTGZbIcRhtErqDsLXiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_b0baea33-dc1c-46e1-ae5b-d577c77e1a52",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "AdventHealth Castle Rock",
      "poi_type": "Health and Wellness",
      "poi_address": "2350 Meadows Blvd, Castle Rock, CO 80109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-76d5-7369-ba73-0f0faf889854.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-76d5-7369-ba73-0f0faf889854",
        "storage_key": "property/6767906449166794/019d02d0-76d5-7369-ba73-0f0faf889854.webp",
        "width": 1183,
        "height": 883
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-castle-rock",
      "poi_directions_map_url": "https://maps.google.com/?cid=13942126042418538948&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adventhealth-castle-rock",
      "poi_latitude": "39.4050596",
      "poi_longitude": "-104.8844609",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 720-455-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2cc2-76f5-a86e-5254f534adc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2cc2-76f5-a86e-5254f534adc8",
        "storage_key": "property/6767906449166794/019d02d0-2cc2-76f5-a86e-5254f534adc8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_f4e6GZbIcRxGkUXMRhfME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2d7fdfbe-53e3-4c6e-ac0c-6ddc363e9a4c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Center Pointe Family Medical Group",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Oakwood Park Plaza suite 101, Castle Rock, CO 80104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-1822-709e-94f0-b5d26aebe4f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-1822-709e-94f0-b5d26aebe4f0",
        "storage_key": "property/6767906449166794/019d02d0-1822-709e-94f0-b5d26aebe4f0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cpfamilymedicine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13581844928271834992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "center-pointe-family-medical-group",
      "poi_latitude": "39.3788788",
      "poi_longitude": "-104.8515273",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 720-667-1825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2cc2-76f5-a86e-5254f534adc8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2cc2-76f5-a86e-5254f534adc8",
        "storage_key": "property/6767906449166794/019d02d0-2cc2-76f5-a86e-5254f534adc8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMW-R48SZbIcRcF8VqABofLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5dd7a9a3-b0b0-4ffa-948c-19a8e77189fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Philip S. Miller Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1375 W Plum Creek Pkwy, Castle Rock, CO 80109, USA",
      "poi_short_description": "320-are public park with a trail network, adventure playground & picnic area with shelters.",
      "poi_long_description": "People say this park offers a variety of activities, including hiking, biking, ziplining, and a playground. They highlight the park's accessibility, with paved paths suitable for wheelchairs, and the abundance of shade. They also like the spaciousness and the many options for adventure.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-1aee-779a-8617-4676a1b79b8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-1aee-779a-8617-4676a1b79b8b",
        "storage_key": "property/6767906449166794/019d02d0-1aee-779a-8617-4676a1b79b8b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.crgov.com/2051/Philip-S-Miller-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12607597900160105291&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "philip-s-miller-park",
      "poi_latitude": "39.3689518",
      "poi_longitude": "-104.879927",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 720-733-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2d17-7749-8b19-dcb184dc2a78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2d17-7749-8b19-dcb184dc2a78",
        "storage_key": "property/6767906449166794/019d02d0-2d17-7749-8b19-dcb184dc2a78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1LSVkKYbIcRS_sABn4v964",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2bdab40d-20c0-4fb6-89a8-e2163980199a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Red Hawk Ridge Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2156 Red Hawk Ridge Dr, Castle Rock, CO 80109, USA",
      "poi_short_description": "Well-rated course with elevated tee boxes, scenic views, and short par 5s that can lead to birdies.",
      "poi_long_description": "Golfers say this golf course offers wide fairways and lots of elevation changes, making it a fun and challenging course. They also highlight that the course is usually kept in good shape and the staff are incredible.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-7be8-7538-8ab7-0abb54ef3769.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-7be8-7538-8ab7-0abb54ef3769",
        "storage_key": "property/6767906449166794/019d02d0-7be8-7538-8ab7-0abb54ef3769.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.redhawkridge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2109260777566691971&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "red-hawk-ridge-golf-course",
      "poi_latitude": "39.3868777",
      "poi_longitude": "-104.8860679",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 720-733-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-3232-74ee-8f48-f3e3a989ca53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-3232-74ee-8f48-f3e3a989ca53",
        "storage_key": "property/6767906449166794/019d02d0-3232-74ee-8f48-f3e3a989ca53.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-el0VKYbIcRg-KGeYCZRR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_a047b266-a2c2-4d97-8d27-7cc68b715310",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Challenge Hill and Trails at Philip S. Miller Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1375 W Plum Creek Pkwy, Castle Rock, CO 80109, USA",
      "poi_short_description": "Regional park with 8 miles of unpaved trails, a playground, and a hill with 200 steps.",
      "poi_long_description": "People say this park offers a challenging 200-step climb with rewarding views, as well as trails, a zipline, and an outdoor gym. They highlight the fun and engaging experience, suitable for all ages and fitness levels, and the well-maintained facilities. They also like the friendly and efficient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-7c59-7085-bd7e-daae6b78a0f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-7c59-7085-bd7e-daae6b78a0f2",
        "storage_key": "property/6767906449166794/019d02d0-7c59-7085-bd7e-daae6b78a0f2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://crgov.com/3248/Philip-S-Miller-Park-Trails-and-Challeng",
      "poi_directions_map_url": "https://maps.google.com/?cid=17258279865812249063&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "challenge-hill-and-trails-at-philip-s-miller-park",
      "poi_latitude": "39.3677914",
      "poi_longitude": "-104.8787784",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 720-733-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2d17-7749-8b19-dcb184dc2a78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2d17-7749-8b19-dcb184dc2a78",
        "storage_key": "property/6767906449166794/019d02d0-2d17-7749-8b19-dcb184dc2a78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5cee2eYbIcR5-kDhBm6ge8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c9834454-726c-4ef4-bfe3-9ebbc5282be9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Butterfield Crossing Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3952 Butterfield Crossing Dr, Castle Rock, CO 80109, USA",
      "poi_short_description": "Park with an outdoor pool, pavilions, sports fields & courts, playgrounds & an inline skating rink.",
      "poi_long_description": "People say this park offers a great play area, pickleball courts, and wheelchair-accessible workout equipment. They highlight the fun and engaging atmosphere, perfect for families and children, and the beautiful views. They also like the quiet and peaceful vibe, and the convenient parking. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-1f52-75df-a288-9649214ada8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-1f52-75df-a288-9649214ada8b",
        "storage_key": "property/6767906449166794/019d02d0-1f52-75df-a288-9649214ada8b.webp",
        "width": 1032,
        "height": 581
      },
      "poi_business_url": "http://crgov.com/3238/Butterfield-Crossing-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9637538686849134028&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "butterfield-crossing-park",
      "poi_latitude": "39.4091319",
      "poi_longitude": "-104.9063491",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-733-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2d17-7749-8b19-dcb184dc2a78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2d17-7749-8b19-dcb184dc2a78",
        "storage_key": "property/6767906449166794/019d02d0-2d17-7749-8b19-dcb184dc2a78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdXoQym2ZbIcRzC26sl9qv4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_395ad6e8-53b0-4580-870a-8020804a6cf2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "poi_name": "Metzler Ranch Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4175 Trail Boss Dr, Castle Rock, CO 80104, USA",
      "poi_short_description": "Park with floodlit baseball & synthetic turf fields, 2 pavilions, a skate park & a playground.",
      "poi_long_description": "Park with floodlit baseball & synthetic turf fields, 2 pavilions, a skate park & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2234-7138-bd50-838e80e84aba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-2234-7138-bd50-838e80e84aba",
        "storage_key": "property/6767906449166794/019d02d0-2234-7138-bd50-838e80e84aba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://crgov.com/3227/Metzler-Ranch-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6388242596909975960&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metzler-ranch-community-park",
      "poi_latitude": "39.4045892",
      "poi_longitude": "-104.8582212",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-733-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019d02d0-2d17-7749-8b19-dcb184dc2a78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-2d17-7749-8b19-dcb184dc2a78",
        "storage_key": "property/6767906449166794/019d02d0-2d17-7749-8b19-dcb184dc2a78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVw0hxsSZbIcRmInWp8uYp1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "custom_aaa843ab-c668-4e61-99a7-55c361fb6aff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "day": "MON",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_cfa7f819-781a-4929-a47d-48c282cda6c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "day": "TUE",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_e335027f-e29c-41ed-9c80-c60152e49ad7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "day": "WED",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_cb2abe5f-9595-4d9a-9d0d-592527bfa547",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "day": "THU",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_6221dc6e-7f50-4c98-8bb2-42c92bc684d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "day": "FRI",
      "open_time": "08:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_c975de4c-02a4-42f6-ada0-a7bd247bc9c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "rating": "5.0",
      "name": "David Jeffries",
      "text": "Joel did an excellent job installing our dishwasher. He was very courteous and kind. Thank you!",
      "date": "2025-10-27",
      "title": ""
    },
    {
      "id": "custom_bf7c9fe4-6691-4d8e-9e1d-24606f5f0f2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "rating": "5.0",
      "name": "Ronda Hubbard",
      "text": "I've had a great experience living here. The staff has been consistently warm, helpful, and professional. The leasing process was smooth, and any time I've had a question or needed maintenance, the response has been prompt and courteous. The apartments are modern, spacious, and thoughtfully designed. The community is always clean and well-maintained, and the location is ideal—perfectly situated between Denver and Colorado Springs.",
      "date": "2025-04-29",
      "title": ""
    },
    {
      "id": "custom_254fca90-1804-4dbe-9993-f7feed872b6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "rating": "5.0",
      "name": "Tanas Mom",
      "text": "I am so impressed by Maddie at The Highlands at Red Hawk. She was so friendly and informative. I was very interested in a particular apartment because of the view but I hesitated and didn't speak up and the next family took it. When Maddie realized I had wanted it, she promised she would call me first if she got one with a similar view. I got a call back the same day from Maddie saying that the family ended up taking a different apartment.\nShe was so helpful through the whole process and went above and beyond what is called for.\nWe are so happy in our new apartment and anything we need is taken care of right away. The maintenence man, Joel, is always on top of things.\nIt's so quiet here and I love seeing  the deer every day. It's convenient for groceries, pharmacy and walking paths here too.",
      "date": "2024-04-05",
      "title": ""
    },
    {
      "id": "custom_a13e6e19-d3e2-4415-810a-bdd0e6fda3f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "rating": "5.0",
      "name": "Brianna Mackey",
      "text": "We moved here 6 months ago and we couldn't be happier. The office manager always does the great activities that are above and beyond. The complex is so quiet and feels very safe. It is kept in great condition and our apartment it absolutely beautiful. So big and has some wonderful features. We live living here so much. We are so lucky to have found this gem.",
      "date": "2024-06-07",
      "title": ""
    },
    {
      "id": "custom_18ef565c-0e5c-4800-a809-28641550edc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "rating": "5",
      "name": "Evelia Arroyo",
      "text": "I moved in site unseen but Bella was kind enough to send me a video tour. My apartment is a pretty good size, new and clean! I’ve had little things but as soon as I called, Bella took care of it immediately! Maintenance guy Joel is super friendly and efficient as well! Can’t wait to meet all my neighbors! Area is pretty quiet, close to many shops and restaurants and the view is very beautiful as well! I’m happy I chose this apartment complex!",
      "date": "2026-08-06",
      "title": "false"
    },
    {
      "id": "custom_983561d2-0823-48c9-a0b0-844c2c1bf899",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "rating": "5",
      "name": "Ashley Hernandez",
      "text": "I’ve been living here since 2023, and I can honestly say it’s been a wonderful place to call home. The property is well-maintained, and anytime I’ve needed maintenance, they’ve responded quickly and resolved the issue efficiently.\n\nOne of the best parts of living here is Isabella, the property manager. She is always kind, professional, and genuinely cares about the residents. She’s easy to communicate with, always willing to help, and goes above and beyond to make sure everything runs smoothly.\n\nThe community is quiet, clean, and feels safe, which has made living here a great experience. I’m grateful to call this place home and would absolutely recommend it to anyone looking for a place to live.",
      "date": "2026-08-06",
      "title": "false"
    },
    {
      "id": "custom_48f508f4-adac-4e2b-b637-c74b677f39ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "rating": "5",
      "name": "Jax Jay",
      "text": "Top notch quick maintenance service. Highly recommend.",
      "date": "2026-08-04",
      "title": "false"
    },
    {
      "id": "custom_1741bf70-2881-4df2-9f06-ba183bf5c72c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "rating": "4",
      "name": "Bud West",
      "text": "Efficient, polite, and prompt\nJoel is absolutely the best\nIn-N-Out in five minutes\nProblem solved\nVery professional",
      "date": "2026-01-02",
      "title": "false"
    },
    {
      "id": "custom_57b36815-15b9-4494-a8c4-2bb1dc5c399c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "rating": "5",
      "name": "Yolanda Ibarra",
      "text": "Easy, efficient move in. Staff had everything ready for me and a welcome bag.\n",
      "date": "2025-12-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_05a69a2d-713b-497d-810f-1466b65fa9ba",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019faa31-73f1-74d6-948c-ecb0a18edf1e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019faa31-73f1-74d6-948c-ecb0a18edf1e",
        "storage_key": "property/6767906449166794/019faa31-73f1-74d6-948c-ecb0a18edf1e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UJN9n1Vnve9"
    },
    {
      "id": "custom_fdcf8a7e-0263-4953-b3f4-0dd72592d971",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019faa32-1825-77d4-a198-9f78962eabd8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019faa32-1825-77d4-a198-9f78962eabd8",
        "storage_key": "property/6767906449166794/019faa32-1825-77d4-a198-9f78962eabd8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ShBh4aXh2Pt"
    },
    {
      "id": "custom_10664811-fcdb-4d5f-bd2a-e3c4713dec87",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166794/019faa32-65a4-7509-a28a-b83b8a4bd3e4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019faa32-65a4-7509-a28a-b83b8a4bd3e4",
        "storage_key": "property/6767906449166794/019faa32-65a4-7509-a28a-b83b8a4bd3e4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1437 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=B3C1xrHPGEJ"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019fa8f6-615f-76d3-b757-b3038ff61ae1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Highlands at Red Hawk Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-castle-rock",
      "search_query": "pet friendly apartments Castle Rock CO",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments Castle Rock CO",
      "h2_subtitle": "Find the best pet-friendly living options in Castle Rock, CO. Experience the perfect blend of comfort and convenience at Highlands at Red Hawk.",
      "page_copy": "At Highlands at Red Hawk, we understand the importance of having a home that welcomes your furry friends. Our pet friendly apartments in Castle Rock, CO, offer spacious living designed with both comfort and convenience in mind. Located in the picturesque setting of Douglas County, our community ensures you're greeted with beautiful landscapes and a warm neighborhood feel.\n\nHighlands at Red Hawk not only provides amenities like breakfast bars and in-home washers and dryers but also boasts a welcoming atmosphere for pets. With extra storage available and a 24-hour courtesy patrol, you can enjoy peace of mind knowing that both you and your pet are taken care of. Discover a home that accommodates all members of your family, furry or otherwise, and experience a community that truly cares.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Castle Rock, CO",
      "seo_description": "Discover pet friendly apartments in Castle Rock, CO at Highlands at Red Hawk. Enjoy comfort and convenience in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "apartments-with-pool-douglas-county",
      "search_query": "apartments with pool Douglas County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Douglas County",
      "h2_subtitle": "Discover modern living with a pool in Douglas County. Highlands at Red Hawk offers resort-style amenities for ultimate relaxation.",
      "page_copy": "Highlands at Red Hawk offers a dynamic blend of comfort and style with its beautifully appointed homes and upscale amenities. Enjoy living in one of the premium apartments with a pool in Douglas County, where relaxation meets convenience. Our community enhances your lifestyle with a comfortable ambiance and resort-style features that make every day feel like a vacation.\n\nLocated in scenic Castle Rock, CO, Highlands at Red Hawk goes beyond expectations. In addition to our refreshing swimming pool, each apartment features essential amenities such as breakfast bars, in-home washers and dryers, and available extra storage. With our 24-hour courtesy patrol, you'll always feel secure and taken care of. Embrace a vibrant community that matches your lifestyle needs and delivers unparalleled comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Douglas County",
      "seo_description": "Explore apartments with a pool in Douglas County at Highlands at Red Hawk. Enjoy luxurious amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-castle-rock",
      "search_query": "in-unit laundry apartments Castle Rock",
      "category": "Amenity",
      "h1_title": "In-unit Laundry Apartments Castle Rock",
      "h2_subtitle": "Experience the convenience of in-unit laundry in Castle Rock. Highlands at Red Hawk offers modern living with essential amenities.",
      "page_copy": "Discover the perfect home at Highlands at Red Hawk, where convenience meets style in our in-unit laundry apartments in Castle Rock. Enjoy the luxury of having a washer and dryer in each home, eliminating the hassle of communal laundry spaces and providing you with more time to relax and enjoy life. Located in the heart of Douglas County, our community offers not only in-unit laundry facilities but also a host of other amenities designed to complement your lifestyle.\n\nOur apartments feature breakfast bars and extra storage options, making everyday living more enjoyable. As a pet-friendly community, Highlands at Red Hawk creates a welcoming environment for all residents, including those with pets. Plus, with our 24-hour courtesy patrol, you can have peace of mind knowing that your comfort and safety are our top priorities. Embrace the ease and elegance that comes with in-unit laundry in our vibrant Castle Rock community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-unit Laundry Apartments in Castle Rock",
      "seo_description": "Find in-unit laundry apartments in Castle Rock at Highlands at Red Hawk. Enjoy modern living with convenient amenities in a beautiful setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "breathtaking-view-apartments-castle-rock",
      "search_query": "apartments with breathtaking views Castle Rock",
      "category": "Amenity",
      "h1_title": "Apartments with Breathtaking Views",
      "h2_subtitle": "Enjoy stunning vistas from your new home in Castle Rock. Highlands at Red Hawk provides panoramic views along with modern amenities.",
      "page_copy": "Welcome to Highlands at Red Hawk, where breathtaking views are part of your everyday life. Nestled in the serene environment of Castle Rock, our community offers apartments with stunning vistas that inspire and soothe. Our location in Douglas County provides a peaceful backdrop, making every moment at home feel both beautiful and invigorating.\n\nBeyond the views, residents enjoy an array of amenities that enhance daily living. Each home features convenient in-unit washers and dryers, breakfast bars, and ample storage. As a pet-friendly community, we embrace all family members, ensuring that everyone feels at home. With a 24-hour courtesy patrol, you can rest easy knowing your community is secure. Come experience life elevated at Highlands at Red Hawk, where unparalleled views and superior services await.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Breathtaking View Apartments in Castle Rock",
      "seo_description": "Discover breathtaking view apartments in Castle Rock at Highlands at Red Hawk. Enjoy stunning vistas and modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-80109",
      "search_query": "fitness center apartments 80109",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in 80109",
      "h2_subtitle": "Achieve your fitness goals at our 80109 apartments. Highlands at Red Hawk offers fitness center amenities in a vibrant community.",
      "page_copy": "Discover Highlands at Red Hawk, where fitness meets comfort in the heart of the 80109 area. Our apartments are perfect for those seeking an active lifestyle with easy access to top-notch fitness center amenities. Situated in the scenic town of Castle Rock, our community is designed to support your wellness journey, ensuring you have everything you need right at home.\n\nAlongside our fitness center, residents enjoy the convenience of in-unit washers and dryers, pet-friendly living, and breakfast bars—adding a touch of modern comfort to every apartment. With extra storage options and a 24-hour courtesy patrol, the Highlands at Red Hawk provides a secure and accommodating environment. Embrace a healthier lifestyle in a community that caters to all aspects of modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 80109",
      "seo_description": "Explore fitness center apartments in 80109 at Highlands at Red Hawk. Enjoy modern amenities and stay active in our Castle Rock community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-castle-rock-co",
      "search_query": "one bedroom apartments Castle Rock CO",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Castle Rock, CO",
      "h2_subtitle": "Find your perfect one bedroom apartment in Castle Rock, CO. Highlands at Red Hawk offers modern amenities and comfortable living spaces.",
      "page_copy": "Welcome to Highlands at Red Hawk, offering exceptional one bedroom apartments in Castle Rock, CO. Perfectly designed to cater to modern living needs, our one bedroom homes provide the ideal combination of comfort and style. With spacious layouts and contemporary finishes, you'll find it easy to create a welcoming environment that truly feels like home.\n\nOur apartments boast fantastic amenities such as in-unit washers and dryers, adding convenience to your daily routine. Enjoy meal prepping in style with breakfast bars and make full use of our extra storage options. Nestled in a pet-friendly community, Highlands at Red Hawk ensures both you and your furry friends are welcomed. Plus, with a 24-hour courtesy patrol, you'll appreciate the focus on safety and peace of mind. Come explore our one bedroom offerings and see why Highlands at Red Hawk is a top choice in Castle Rock.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Castle Rock, CO",
      "seo_description": "Discover one bedroom apartments in Castle Rock, CO at Highlands at Red Hawk. Enjoy modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-80109",
      "search_query": "two bedroom apartments near 80109",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 80109",
      "h2_subtitle": "Explore spacious two bedroom apartments near 80109. Highlands at Red Hawk offers comfort and convenience in Castle Rock.",
      "page_copy": "Discover the perfect two bedroom apartments near the 80109 area at Highlands at Red Hawk. Ideal for families, roommates, or anyone seeking extra space, our two bedroom homes offer a blend of style and practicality. Each unit is designed to maximize comfort with open layouts and modern fixtures, giving you the perfect backdrop for living comfortably in Castle Rock.\n\nResidents at Highlands at Red Hawk enjoy an array of amenities that enhance their living experience. From in-unit washers and dryers to convenient breakfast bars, every detail is carefully considered. Our pet-friendly policy ensures that all family members feel at home, while our extra storage options provide plenty of room to stay organized. With the peace of mind provided by a 24-hour courtesy patrol, you can fully enjoy the convenience and community feel of Highlands at Red Hawk. Come see why our two bedroom options are the ideal choice near 80109.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 80109",
      "seo_description": "Find spacious two bedroom apartments near 80109 at Highlands at Red Hawk. Enjoy modern amenities and a supportive community in Castle Rock.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-douglas-county",
      "search_query": "three bedroom apartments in Douglas County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Douglas County",
      "h2_subtitle": "Discover spacious three bedroom apartments in Douglas County. Highlands at Red Hawk offers ample living space with modern amenities.",
      "page_copy": "Experience the best of Douglas County living at Highlands at Red Hawk, where our three bedroom apartments combine ample space and modern convenience. Perfect for families or individuals seeking extra room, each apartment is thoughtfully designed to accommodate a variety of lifestyles. Enjoy a welcoming environment with stylish interiors and plenty of natural light.\n\nOur community offers a variety of amenities that enhance everyday living. With features such as in-unit washers and dryers, flexible storage options, and breakfast bars, our apartments provide both luxury and functionality. As a pet-friendly community, even your furry companions will feel at home. The presence of a 24-hour courtesy patrol further ensures the safety and peace of mind of all residents. Located in beautiful Castle Rock, Highlands at Red Hawk captures the essence of comfort and convenience in Douglas County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Douglas County",
      "seo_description": "Explore three bedroom apartments in Douglas County at Highlands at Red Hawk. Enjoy modern living and a welcoming community in Castle Rock.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "apartments-near-arapahoe-community-college-castle-rock",
      "search_query": "apartments near Arapahoe Community College Castle Rock CO",
      "category": "School",
      "h1_title": "Apartments Near Arapahoe Community College",
      "h2_subtitle": "Find apartments near Arapahoe Community College in Castle Rock, CO. Highlands at Red Hawk offers convenience and comfort for students and families.",
      "page_copy": "Highlands at Red Hawk is the perfect place to call home if you're looking for apartments near Arapahoe Community College in Castle Rock, CO. Our location provides easy access to the college, making it ideal for students and staff seeking a convenient and comfortable living option. Our community combines modern apartment features with a friendly atmosphere to enrich your residential experience.\n\nEnjoy a range of amenities designed to complement your lifestyle. Each apartment includes a washer and dryer, along with spacious breakfast bars, perfect for both everyday living and entertaining friends. As a pet-friendly community, we welcome your furry friends with open arms, and we provide extra storage options to keep your home tidy and organized. With a 24-hour courtesy patrol, you can enjoy peace of mind and focus on what truly matters, whether studying or relaxing. Experience the perfect blend of convenience and comfort at Highlands at Red Hawk.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Arapahoe Community College",
      "seo_description": "Discover convenient living at Highlands at Red Hawk, offering apartments near Arapahoe Community College in Castle Rock, CO with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "apartments-near-adventhealth-castle-rock",
      "search_query": "apartments near adventhealth castle rock",
      "category": "Hospital",
      "h1_title": "Apartments Near AdventHealth Castle Rock",
      "h2_subtitle": "Find convenient apartments near AdventHealth Castle Rock. Highlands at Red Hawk provides modern living with easy hospital access.",
      "page_copy": "If you're searching for apartments near AdventHealth Castle Rock, look no further than Highlands at Red Hawk. Located a short drive from the hospital, our community is ideal for healthcare professionals, patients, and families seeking a close-knit neighborhood with modern conveniences. Enjoy a harmonious balance between comfortable living and easy access to one of the region's top medical facilities.\n\nOur community boasts a variety of amenities designed to meet your needs. Each apartment features a washer and dryer, breakfast bars, and the option for additional storage, promoting a hassle-free lifestyle. We welcome pets, ensuring every member of your household feels at home. Take advantage of our 24-hour courtesy patrol for added peace of mind while living in a welcoming environment. Enjoy the blend of modern comfort and proximity to AdventHealth Castle Rock right here at Highlands at Red Hawk.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near AdventHealth Castle Rock",
      "seo_description": "Highlands at Red Hawk offers apartments near AdventHealth Castle Rock with modern amenities and convenient access to healthcare facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "apartments-close-to-center-pointe-family-medical-group",
      "search_query": "apartments close to center pointe family medical group castle rock",
      "category": "Hospital",
      "h1_title": "Apartments Close to Center Pointe Family Medical",
      "h2_subtitle": "Live close to Center Pointe Family Medical Group in Castle Rock. Discover comfortable living at Highlands at Red Hawk, just minutes away.",
      "page_copy": "Highlands at Red Hawk offers the perfect solution for those seeking apartments close to Center Pointe Family Medical Group, located in the charming area of Castle Rock. Our community is ideally situated for convenient access to medical care and family-friendly amenities, making it an excellent choice for healthcare professionals and families alike.\n\nEnjoy a community that emphasizes comfort and convenience, with each apartment featuring in-unit washers and dryers, handy breakfast bars, and options for extra storage. With pet-friendly policies, your entire household, including furry friends, will feel welcome. Safety and tranquility are priorities, supported by our diligent 24-hour courtesy patrol. Experience the blend of modern living and easy access to essential services at Highlands at Red Hawk, where location and lifestyle meet.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Center Pointe Family Medical",
      "seo_description": "Discover Highlands at Red Hawk, offering apartments close to Center Pointe Family Medical Group in Castle Rock, with modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "apartments-near-philip-s-miller-park-castle-rock",
      "search_query": "apartments near Philip S. Miller Park Castle Rock",
      "category": "Park",
      "h1_title": "Apartments Near Philip S. Miller Park",
      "h2_subtitle": "Discover living near Philip S. Miller Park in Castle Rock. Highlands at Red Hawk offers convenient, nature-inspired living.",
      "page_copy": "For those wanting the best of both worlds—nature and convenience—Highlands at Red Hawk is the ideal choice, located near Philip S. Miller Park in Castle Rock. Our community provides quick access to this remarkable recreational area, perfect for outdoor enthusiasts and families who appreciate an active lifestyle amid beautiful natural scenery.\n\nResidents at Highlands at Red Hawk benefit from amenities designed to complement their lifestyle, such as in-home washers and dryers, breakfast bars ideal for quick or leisurely meals, and extra storage options to keep spaces organized. As a pet-friendly community, we welcome every family member—two-legged and four—with care. Our 24-hour courtesy patrol ensures peace of mind, allowing you to enjoy both the vibrant community and proximity to the stunning attractions of Philip S. Miller Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Philip S. Miller Park",
      "seo_description": "Experience nature and comfort at Highlands at Red Hawk, offering apartments near Philip S. Miller Park in Castle Rock with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "highlands-at-red-hawk-challenge-hill-trails",
      "search_query": "Highlands at Red Hawk close to Challenge Hill and Trails CO",
      "category": "Park",
      "h1_title": "Highlands at Red Hawk Near Challenge Hill",
      "h2_subtitle": "Explore living close to Challenge Hill and Trails in CO. Highlands at Red Hawk offers an active lifestyle with stunning trail access.",
      "page_copy": "Nestled in the natural beauty of Castle Rock, Highlands at Red Hawk is perfect for those seeking proximity to Challenge Hill and Trails. This location offers residents the opportunity for adventure and exploration right at their doorstep. Enjoy the thrilling climbs and picturesque views that Challenge Hill is renowned for, all while living in comfort.\n\nAt Highlands at Red Hawk, our residents experience the best of both worlds with amenities like breakfast bars, in-home washers and dryers, and extra storage to keep gear organized. With a pet-friendly policy, every family member is welcome to join in the fun. Meanwhile, our 24-hour courtesy patrol helps ensure a secure environment. Choose Highlands at Red Hawk for a lifestyle that embraces both modern living and outdoor recreation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Highlands at Red Hawk Near Challenge Hill",
      "seo_description": "Live at Highlands at Red Hawk, close to Challenge Hill and Trails in CO, offering convenient amenities and access to beautiful outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "butterfield-crossing-park-nearby-apartments",
      "search_query": "Butterfield Crossing Park nearby apartments Douglas County",
      "category": "Park",
      "h1_title": "Apartments Near Butterfield Crossing Park",
      "h2_subtitle": "Find comfortable living near Butterfield Crossing Park in Douglas County. Highlands at Red Hawk offers ideal proximity and modern conveniences.",
      "page_copy": "Highlands at Red Hawk presents an inviting community located near Butterfield Crossing Park in the heart of Douglas County. This makes it the perfect residence for those who cherish easy access to outdoor adventures and the vibrant local lifestyle. Residents can enjoy everything from leisurely strolls to recreational activities just moments away.\n\nOur apartments offer a wealth of amenities, including in-unit washers and dryers, spacious breakfast bars, and available extra storage to suit your lifestyle needs. As a pet-friendly community, all members of the family can feel at home. A round-the-clock courtesy patrol ensures the safety and peace of mind of our residents. Choose Highlands at Red Hawk for a home that combines modern comfort with the joys of living near Butterfield Crossing Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Butterfield Crossing Park",
      "seo_description": "Discover Highlands at Red Hawk for modern living near Butterfield Crossing Park in Douglas County, with great amenities and proximity to local parks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166794",
      "source": "generator",
      "page_item_url": "apartments-near-metzler-ranch-community-park-80109",
      "search_query": "apartments near Metzler Ranch Community Park 80109",
      "category": "Park",
      "h1_title": "Apartments Near Metzler Ranch Park",
      "h2_subtitle": "Discover homes near Metzler Ranch Community Park in the 80109 area. Highlands at Red Hawk offers luxurious living with nature at your doorstep.",
      "page_copy": "Located within the scenic 80109 area, Highlands at Red Hawk offers the perfect balance of luxury and nature near Metzler Ranch Community Park. This prime location grants residents quick access to a variety of outdoor activities, from sports fields to serene walking trails, perfect for an active or leisurely lifestyle.\n\nOur community is thoughtfully equipped with features such as in-home washers and dryers, convenient breakfast bars, and extra storage options—ideal for managing both daily routines and weekend adventures. Since we are a pet-friendly community, every furry friend is welcome, so you can enjoy the great outdoors together. With a 24-hour courtesy patrol, peace of mind comes standard. Choose Highlands at Red Hawk for a living experience that's as dynamic as it is comfortable, all near the stunning Metzler Ranch Community Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Metzler Ranch Park",
      "seo_description": "Live at Highlands at Red Hawk, near Metzler Ranch Community Park in the 80109 area, offering premium amenities and a location perfect for park enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6027"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10715005141"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WLFGZR3M"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "140HRH"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('KOayhijBtRzEfCUMxu')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "41621673074"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/m9pz8nx7pk1"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "ER100107678"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amcllc_highlandsatredhawk_web_propertywebsite@leads.anyonehome.com"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Highlands at Red Hawk/scheduletourwidget/kutzgwJP49JFj65GD4/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImlxdE1ONitML05nS2Y0bFNVa29QUHc9PSIsInZhbHVlIjoiMGQzcC91Ym5jWmVKdVpKUVFPQnd1QT09IiwibWFjIjoiMTcyZGVkZDBhZGE4ODI2OTQ0YzBhNzA1YzY4NDFhNTc3NzBhZmI4YWZjNzllNDlmNGIyNDA1YTQyNWM5NGFlMSJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "6027",
  "custom_repli_id": "10715005141",
  "custom_google_gtm_id": "GTM-WLFGZR3M",
  "custom_rollout_phase": "Pathfinder 2",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "none",
  "custom_aim_property_code": "140HRH",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('KOayhijBtRzEfCUMxu')</script>",
  "custom_hubspot_company_id": "41621673074",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/m9pz8nx7pk1",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "ER100107678",
  "custom_website_tracking_email": "amcllc_highlandsatredhawk_web_propertywebsite@leads.anyonehome.com",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Highlands at Red Hawk/scheduletourwidget/kutzgwJP49JFj65GD4/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImlxdE1ONitML05nS2Y0bFNVa29QUHc9PSIsInZhbHVlIjoiMGQzcC91Ym5jWmVKdVpKUVFPQnd1QT09IiwibWFjIjoiMTcyZGVkZDBhZGE4ODI2OTQ0YzBhNzA1YzY4NDFhNTc3NzBhZmI4YWZjNzllNDlmNGIyNDA1YTQyNWM5NGFlMSJ9",
  "custom_audioeye_site_id": "dd9c8fa1-7f00-4c3c-9cd5-a197ddae6196",
  "custom_audioeye_site_hash": "2c13965666c4113607a7d05515f1099f"
};

export const generatedAt = '2026-10-08T20:11:36.824Z';
